"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8148],{

/***/ 58386:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ ROLE_IDS; }
/* harmony export */ });
/* unused harmony export ROLES */
var ROLE_IDS = [
    "4eb9a965-9c68-4b45-82bd-4fb9599e5fb5",
    "a5777b73-482f-47a1-9887-a95ebf61dad4",
    "c25269d8-4b5e-4e6e-b742-ee895a61c50a",
    "db0a4d6f-1c60-4e43-86c3-ea59c8a94e0b",
    "387a7efa-d062-4d67-b568-a5f2f29b3702",
    "e393ad1a-4aa0-443a-a354-50f2aeb86915", 
];
var ROLES = [
    {
        role_name: "PHI Admin",
        role_description: "Level 1 Description",
        role_id: ROLE_IDS[0],
        actions: {
            connect: [
                {
                    action_id: "ManageAllClients"
                },
                {
                    action_id: "ManageEnterpriseClients"
                },
                {
                    action_id: "OrganizationRead"
                },
                {
                    action_id: "OrganizationCreate"
                },
                {
                    action_id: "OrganizationUpdate"
                },
                {
                    action_id: "OrganizationDelete"
                },
                {
                    action_id: "RiskRegistryRead"
                },
                {
                    action_id: "AssessmentRead"
                },
                {
                    action_id: "TrainingProgramRead"
                },
                {
                    action_id: "TrainingProgramCreate"
                },
                {
                    action_id: "TrainingProgramUpdate"
                },
                {
                    action_id: "TrainingProgramDelete"
                },
                {
                    action_id: "PolicyManagerRead"
                },
                {
                    action_id: "DocumentRead"
                },
                {
                    action_id: "CoachRead"
                },
                {
                    action_id: "CoachCreate"
                },
                {
                    action_id: "CoachUpdate"
                },
                {
                    action_id: "CoachDelete"
                },
                {
                    action_id: "CoachEngagementRead"
                },
                {
                    action_id: "CoachSessionRead"
                },
                {
                    action_id: "ResourceRead"
                },
                {
                    action_id: "ResourceUpdate"
                },
                {
                    action_id: "ResourceCreate"
                },
                {
                    action_id: "ResourceDelete"
                },
                {
                    action_id: "UserRead"
                },
                {
                    action_id: "UserCreate"
                },
                {
                    action_id: "UserDelete"
                },
                {
                    action_id: "UserUpdate"
                },
                {
                    action_id: "PolicyTemplateRead"
                },
                {
                    action_id: "PolicyTemplateUpdate"
                },
                {
                    action_id: "PolicyTemplateCreate"
                },
                {
                    action_id: "PolicyTemplateDelete"
                },
                {
                    action_id: "AssessmentTemplateRead"
                },
                {
                    action_id: "AssessmentTemplateUpdate"
                },
                {
                    action_id: "AssessmentTemplateCreate"
                },
                {
                    action_id: "AssessmentTemplateDelete"
                },
                {
                    action_id: "AuditLogRead"
                },
                {
                    action_id: "AdminUserRead"
                },
                {
                    action_id: "AdminUserUpdate"
                },
                {
                    action_id: "AdminUserCreate"
                },
                {
                    action_id: "AdminUserDelete"
                },
                {
                    action_id: "IncidentStakeholderRead"
                },
                {
                    action_id: "IncidentRead"
                }, 
            ]
        },
        menus: {
            connect: [
                {
                    menu_id: "admin_dashboard"
                },
                {
                    menu_id: "phi_settings"
                },
                {
                    menu_id: "coach"
                },
                {
                    menu_id: "clients"
                },
                {
                    menu_id: "resources"
                },
                {
                    menu_id: "privacy_community"
                },
                {
                    menu_id: "audit_logs"
                },
                {
                    menu_id: "policy_templates"
                },
                {
                    menu_id: "assessment_templates"
                },
                {
                    menu_id: "incident_management"
                }, 
            ]
        }
    },
    {
        role_name: "Coach",
        role_description: "Level 2",
        role_id: ROLE_IDS[1],
        actions: {
            connect: [
                {
                    action_id: "ManageAllClients"
                },
                {
                    action_id: "ManageEnterpriseClients"
                },
                {
                    action_id: "OrganizationRead"
                },
                {
                    action_id: "OrganizationCreate"
                },
                {
                    action_id: "OrganizationUpdate"
                },
                {
                    action_id: "OrganizationDelete"
                },
                {
                    action_id: "RiskRegistryRead"
                },
                {
                    action_id: "AssessmentRead"
                },
                {
                    action_id: "AssessmentCreate"
                },
                {
                    action_id: "AssessmentUpdate"
                },
                {
                    action_id: "AssessmentDelete"
                },
                {
                    action_id: "TrainingProgramRead"
                },
                {
                    action_id: "TrainingProgramCreate"
                },
                {
                    action_id: "TrainingProgramUpdate"
                },
                {
                    action_id: "TrainingProgramDelete"
                },
                {
                    action_id: "PolicyManagerRead"
                },
                {
                    action_id: "PolicyManagerCreate"
                },
                {
                    action_id: "PolicyManagerUpdate"
                },
                {
                    action_id: "PolicyManagerDelete"
                },
                {
                    action_id: "DocumentRead"
                },
                {
                    action_id: "DocumentCreate"
                },
                {
                    action_id: "DocumentDelete"
                },
                {
                    action_id: "DocumentUpdate"
                },
                {
                    action_id: "CoachRead"
                },
                {
                    action_id: "CoachCreate"
                },
                {
                    action_id: "CoachUpdate"
                },
                {
                    action_id: "CoachDelete"
                },
                {
                    action_id: "CoachEngagementRead"
                },
                {
                    action_id: "CoachEngagementCreate"
                },
                {
                    action_id: "CoachEngagementUpdate"
                },
                {
                    action_id: "CoachEngagementDelete"
                },
                {
                    action_id: "CoachSessionRead"
                },
                {
                    action_id: "CoachSessionCreate"
                },
                {
                    action_id: "CoachSessionUpdate"
                },
                {
                    action_id: "CoachSessionDelete"
                },
                {
                    action_id: "ResourceRead"
                },
                {
                    action_id: "ResourceUpdate"
                },
                {
                    action_id: "ResourceCreate"
                },
                {
                    action_id: "ResourceDelete"
                },
                {
                    action_id: "UserRead"
                },
                {
                    action_id: "UserCreate"
                },
                {
                    action_id: "UserDelete"
                },
                {
                    action_id: "UserUpdate"
                },
                {
                    action_id: "AdminUserRead"
                },
                {
                    action_id: "IncidentStakeholderRead"
                },
                {
                    action_id: "IncidentRead"
                }, 
            ]
        },
        menus: {
            connect: [
                {
                    menu_id: "coach_dashboard"
                },
                {
                    menu_id: "coach"
                },
                {
                    menu_id: "chat"
                },
                {
                    menu_id: "resources"
                },
                {
                    menu_id: "privacy_community"
                },
                {
                    menu_id: "incident_management"
                }, 
            ]
        }
    },
    {
        role_name: "Organization Admin",
        role_description: "Level 3",
        role_id: ROLE_IDS[2],
        actions: {
            connect: [
                {
                    action_id: "OrganizationRead"
                },
                {
                    action_id: "OrganizationCreate"
                },
                {
                    action_id: "OrganizationUpdate"
                },
                {
                    action_id: "OrganizationDelete"
                },
                {
                    action_id: "RiskRegistryRead"
                },
                {
                    action_id: "AssessmentRead"
                },
                {
                    action_id: "AssessmentCreate"
                },
                {
                    action_id: "AssessmentUpdate"
                },
                {
                    action_id: "AssessmentDelete"
                },
                {
                    action_id: "TrainingProgramRead"
                },
                {
                    action_id: "PolicyManagerRead"
                },
                {
                    action_id: "PolicyManagerCreate"
                },
                {
                    action_id: "PolicyManagerUpdate"
                },
                {
                    action_id: "PolicyManagerDelete"
                },
                {
                    action_id: "DocumentRead"
                },
                {
                    action_id: "DocumentCreate"
                },
                {
                    action_id: "DocumentDelete"
                },
                {
                    action_id: "DocumentUpdate"
                },
                {
                    action_id: "CoachRead"
                },
                {
                    action_id: "CoachEngagementRead"
                },
                {
                    action_id: "CoachEngagementCreate"
                },
                {
                    action_id: "CoachEngagementUpdate"
                },
                {
                    action_id: "CoachEngagementDelete"
                },
                {
                    action_id: "CoachSessionRead"
                },
                {
                    action_id: "CoachSessionCreate"
                },
                {
                    action_id: "CoachSessionUpdate"
                },
                {
                    action_id: "CoachSessionDelete"
                },
                {
                    action_id: "ResourceRead"
                },
                {
                    action_id: "UserRead"
                },
                {
                    action_id: "UserCreate"
                },
                {
                    action_id: "UserDelete"
                },
                {
                    action_id: "UserUpdate"
                },
                {
                    action_id: "IncidentStakeholderRead"
                },
                {
                    action_id: "IncidentStakeholderCreate"
                },
                {
                    action_id: "IncidentStakeholderUpdate"
                },
                {
                    action_id: "IncidentStakeholderDelete"
                },
                {
                    action_id: "IncidentRead"
                },
                {
                    action_id: "IncidentCreate"
                },
                {
                    action_id: "IncidentUpdate"
                },
                {
                    action_id: "IncidentDelete"
                }, 
            ]
        },
        menus: {
            connect: [
                {
                    menu_id: "dashboard"
                },
                {
                    menu_id: "risk_registry"
                },
                {
                    menu_id: "assessments"
                },
                {
                    menu_id: "training"
                },
                {
                    menu_id: "policy_manager"
                },
                {
                    menu_id: "document_library"
                },
                {
                    menu_id: "coach"
                },
                {
                    menu_id: "chat"
                },
                {
                    menu_id: "resources"
                },
                {
                    menu_id: "privacy_community"
                },
                {
                    menu_id: "incident_management"
                }, 
            ]
        }
    },
    {
        role_name: "Organization User",
        role_description: "Level 4",
        role_id: ROLE_IDS[3],
        actions: {
            connect: [
                {
                    action_id: "AssessmentRead"
                },
                {
                    action_id: "AssessmentUpdate"
                },
                {
                    action_id: "PolicyManagerRead"
                },
                {
                    action_id: "DocumentRead"
                },
                {
                    action_id: "DocumentCreate"
                },
                {
                    action_id: "DocumentUpdate"
                },
                {
                    action_id: "ResourceRead"
                },
                {
                    action_id: "OrganizationRead"
                }, 
            ]
        },
        menus: {
            connect: [
                {
                    menu_id: "dashboard"
                },
                {
                    menu_id: "assessments"
                },
                {
                    menu_id: "policy_manager"
                },
                {
                    menu_id: "document_library"
                },
                {
                    menu_id: "resources"
                }, 
            ]
        }
    },
    {
        role_name: "Enterprise Org Admin",
        role_description: "Level 5",
        role_id: ROLE_IDS[4],
        actions: {
            connect: [
                {
                    action_id: "ManageEnterpriseClients"
                }
            ]
        },
        menus: {
            connect: [
                {
                    menu_id: "dashboard"
                },
                {
                    menu_id: "risk_registry"
                },
                {
                    menu_id: "assessments"
                },
                {
                    menu_id: "chat"
                },
                {
                    menu_id: "resources"
                },
                {
                    menu_id: "privacy_community"
                },
                {
                    menu_id: "incident_management"
                }, 
            ]
        }
    },
    {
        role_name: "Auditor",
        role_description: "Level 6",
        role_id: ROLE_IDS[5],
        actions: {
            connect: [
                {
                    action_id: "OrganizationRead"
                },
                {
                    action_id: "RiskRegistryRead"
                },
                {
                    action_id: "AssessmentRead"
                },
                {
                    action_id: "PolicyManagerRead"
                },
                {
                    action_id: "DocumentRead"
                },
                {
                    action_id: "UserRead"
                },
                {
                    action_id: "ManageAllClients"
                }, 
            ]
        },
        menus: {
            connect: [
                {
                    menu_id: "risk_registry"
                },
                {
                    menu_id: "assessments"
                },
                {
                    menu_id: "policy_manager"
                },
                {
                    menu_id: "document_library"
                },
                {
                    menu_id: "clients"
                }, 
            ]
        }
    }, 
];


/***/ }),

/***/ 59578:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ SOC2_ADD_ON_NAMES; }
/* harmony export */ });
var SOC2_ADD_ON_NAMES = [
    {
        name: "SOC2 Type I pre-audit",
        addon_id: "8af5247e-1a2a-4438-b056-11640136c61f",
        description: ""
    },
    {
        name: "SOC2 Type II pre-audit",
        addon_id: "6967e96b-dd0c-4c75-b7a8-0dbaca11f1c4",
        description: ""
    },
    {
        name: "SOC2 Assessment",
        addon_id: "e81e6370-b61a-4187-8789-58e9f5f7ad7f",
        description: ""
    }, 
];


/***/ }),

/***/ 14191:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ ADDON_IDS; }
/* harmony export */ });
/* harmony import */ var _seeds_data_soc2_addons__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59578);

var ADDON_IDS = {
    coachingHours: "7b4840db-7e40-41a5-a058-2e1acc319514",
    trainingSeats: "70b14daf-521e-4bdd-a447-3e4b9b06e0a0",
    phiShield: "76e83c3b-905d-445b-8dac-21156d32f51c",
    phiShieldPlus: "b0d523ea-e057-4439-ba15-0656b1463ad0",
    imAddOn: "177f1e5a-97c9-476c-a5e8-cc7399517a19",
    nonRecurringCoaching: "54a76206-6f27-4bb0-b57b-cbbeb1339648",
    soc2Type1: _seeds_data_soc2_addons__WEBPACK_IMPORTED_MODULE_0__/* .SOC2_ADD_ON_NAMES[0].addon_id */ .N[0].addon_id,
    soc2Type2: _seeds_data_soc2_addons__WEBPACK_IMPORTED_MODULE_0__/* .SOC2_ADD_ON_NAMES[1].addon_id */ .N[1].addon_id,
    soc2Assessment: _seeds_data_soc2_addons__WEBPACK_IMPORTED_MODULE_0__/* .SOC2_ADD_ON_NAMES[2].addon_id */ .N[2].addon_id
};


/***/ }),

/***/ 84855:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99226);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_perfect_scrollbar__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51964);
/* harmony import */ var react_perfect_scrollbar__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_perfect_scrollbar__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_perfect_scrollbar_dist_css_styles_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(65369);
/* harmony import */ var react_perfect_scrollbar_dist_css_styles_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react_perfect_scrollbar_dist_css_styles_css__WEBPACK_IMPORTED_MODULE_3__);





function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Scrollbar = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(props, ref) {
    var children = props.children, other = _objectWithoutProperties(props, [
        "children"
    ]);
    // NextJS does not like this too much
    var isMobile = false;
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (isMobile) {
        return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            ref: ref,
            sx: {
                overflowX: "auto"
            },
            children: children
        }));
    }
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((react_perfect_scrollbar__WEBPACK_IMPORTED_MODULE_2___default()), _objectSpread({
        // @ts-expect-error
        ref: ref
    }, other, {
        children: children
    })));
});
/* harmony default export */ __webpack_exports__["Z"] = (Scrollbar);


/***/ }),

/***/ 63016:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ SkeletonLoader; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62623);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86867);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(28492);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(23972);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(22054);
/* harmony import */ var _mui_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66684);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);




function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var useStyles = (0,_mui_styles__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(theme) {
    return {
        skeleton: {
            borderRadius: theme.shape.borderRadius,
            transform: "none"
        }
    };
});
var SkeletonLoader = function(_param) {
    var loading = _param.loading, children = _param.children, _animation = _param.animation, animation = _animation === void 0 ? "wave" : _animation, _width = _param.width, width = _width === void 0 ? "100%" : _width, error = _param.error, props = _objectWithoutProperties(_param, [
        "loading",
        "children",
        "animation",
        "width",
        "error"
    ]);
    var classes = useStyles();
    if (error) {
        return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    title: error.error
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                        variant: "body2",
                        children: error.message
                    })
                })
            ]
        }));
    }
    if (loading) {
        return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, _objectSpread({
            width: width,
            animation: animation,
            className: classes.skeleton
        }, props, {
            children: children
        })));
    }
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: children
    }));
};



/***/ }),

/***/ 70186:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ UploadedAvatar; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87952);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var UploadedAvatar = function(_param) {
    var image = _param.image, props = _objectWithoutProperties(_param, [
        "image"
    ]);
    if (!image) return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread({}, props)));
    var base64 = Buffer.from(image).toString("base64");
    var src = "data:image/png;base64,".concat(base64);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _objectSpread({}, props, {
        src: src
    })));
};



/***/ }),

/***/ 18148:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ dashboard_DashboardLayout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/Container/Container.js
var Container = __webpack_require__(46574);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 1 modules
var Grid = __webpack_require__(48263);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js
var Typography = __webpack_require__(23972);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js + 2 modules
var styled = __webpack_require__(11496);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./seeds/data/role.ts
var data_role = __webpack_require__(58386);
// EXTERNAL MODULE: ./node_modules/@mui/material/AppBar/AppBar.js
var AppBar = __webpack_require__(89206);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js
var Box = __webpack_require__(99226);
// EXTERNAL MODULE: ./node_modules/@mui/material/Toolbar/Toolbar.js
var Toolbar = __webpack_require__(83808);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js
var IconButton = __webpack_require__(54799);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/esm/ManageAccounts.js
var ManageAccounts = __webpack_require__(83784);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/esm/Logout.js
var Logout = __webpack_require__(39029);
// EXTERNAL MODULE: ./node_modules/@mui/material/ButtonBase/ButtonBase.js + 2 modules
var ButtonBase = __webpack_require__(41844);
// EXTERNAL MODULE: ./node_modules/@mui/material/Popover/Popover.js
var Popover = __webpack_require__(90103);
// EXTERNAL MODULE: ./node_modules/@mui/material/List/List.js
var List = __webpack_require__(18843);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListItem/ListItem.js
var ListItem = __webpack_require__(29861);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListItemButton/ListItemButton.js
var ListItemButton = __webpack_require__(98619);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListItemIcon/ListItemIcon.js
var ListItemIcon = __webpack_require__(48885);
// EXTERNAL MODULE: ./node_modules/@mui/material/ListItemText/ListItemText.js
var ListItemText = __webpack_require__(59334);
// EXTERNAL MODULE: ./node_modules/notistack/dist/notistack.esm.js
var notistack_esm = __webpack_require__(73400);
// EXTERNAL MODULE: ./node_modules/@mui/material/Switch/Switch.js
var Switch = __webpack_require__(72852);
// EXTERNAL MODULE: ./src/constants/themes.ts
var themes = __webpack_require__(24742);
// EXTERNAL MODULE: ./src/hooks/useSettings.ts
var useSettings = __webpack_require__(10901);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/createSvgIcon.js
var createSvgIcon = __webpack_require__(82066);
;// CONCATENATED MODULE: ./src/icons/Moon.tsx


var Moon = (0,createSvgIcon/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
        d: "M17.293 13.293A8 8 0 016.707 2.707a8.001 8.001 0 1010.586 10.586z"
    })
}), "Moon");
/* harmony default export */ var icons_Moon = (Moon);

;// CONCATENATED MODULE: ./src/icons/Sun.tsx


var Sun = (0,createSvgIcon/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
        fillRule: "evenodd",
        d: "M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z",
        clipRule: "evenodd"
    })
}), "Sun");
/* harmony default export */ var icons_Sun = (Sun);

;// CONCATENATED MODULE: ./src/components/ThemeSwitcher.tsx







function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var ThemeSwitcher = function() {
    var ref = (0,useSettings/* default */.Z)(), settings = ref.settings, saveSettings = ref.saveSettings;
    var handleSwitch = function() {
        if (settings.theme === themes/* THEMES.LIGHT */.y.LIGHT) {
            saveSettings(_objectSpread({}, settings, {
                theme: themes/* THEMES.DARK */.y.DARK
            }));
        } else if (settings.theme === themes/* THEMES.DARK */.y.DARK) {
            saveSettings(_objectSpread({}, settings, {
                theme: themes/* THEMES.LIGHT */.y.LIGHT
            }));
        }
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        sx: {
            display: "flex",
            alignItems: "center"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Sun, {
                fontSize: "small"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Switch/* default */.Z, {
                checked: settings.theme === themes/* THEMES.DARK */.y.DARK,
                onChange: handleSwitch,
                name: "",
                color: "primary",
                size: "small"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Moon, {
                fontSize: "small"
            })
        ]
    }));
};

// EXTERNAL MODULE: ./src/components/UploadedAvatar.tsx
var UploadedAvatar = __webpack_require__(70186);
// EXTERNAL MODULE: ./src/constants/routes.ts
var routes = __webpack_require__(46648);
// EXTERNAL MODULE: ./src/hooks/useAuth.ts
var useAuth = __webpack_require__(78470);
// EXTERNAL MODULE: ./src/requests/queries/index.ts + 41 modules
var queries = __webpack_require__(21491);
;// CONCATENATED MODULE: ./src/components/Popover/AccountPopover.tsx













function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function AccountPopover_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function AccountPopover_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            AccountPopover_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var AccountPopover = function() {
    var anchorRef = (0,react.useRef)(null);
    var router = (0,next_router.useRouter)();
    var ref = (0,useAuth/* default */.Z)(), authUser = ref.user, logout = ref.logout;
    var user = (0,queries/* useUser */.aF)(authUser === null || authUser === void 0 ? void 0 : authUser.user_id).user;
    var enqueueSnackbar = (0,notistack_esm/* useSnackbar */.Ds)().enqueueSnackbar;
    var ref1 = (0,react.useState)(false), open = ref1[0], setOpen = ref1[1];
    var ref2 = (0,useSettings/* default */.Z)(), settings = ref2.settings, saveSettings = ref2.saveSettings;
    var handleOpen = function() {
        setOpen(true);
    };
    var handleClose = function() {
        setOpen(false);
    };
    var handleLogout = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        handleClose();
                        saveSettings(AccountPopover_objectSpread({}, settings, {
                            isViewAs: undefined
                        }));
                        _ctx.next = 5;
                        return logout();
                    case 5:
                        router.push(routes/* ROUTES.AUTH_LOGIN */.Z.AUTH_LOGIN);
                        _ctx.next = 12;
                        break;
                    case 8:
                        _ctx.prev = 8;
                        _ctx.t0 = _ctx["catch"](0);
                        console.error(_ctx.t0);
                        enqueueSnackbar("Unable to logout", {
                            anchorOrigin: {
                                horizontal: "right",
                                vertical: "top"
                            },
                            variant: "error"
                        });
                    case 12:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    8
                ]
            ]);
        }));
        return function handleLogout() {
            return _ref.apply(this, arguments);
        };
    }();
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                component: ButtonBase/* default */.Z,
                onClick: handleOpen,
                ref: anchorRef,
                sx: {
                    alignItems: "center",
                    display: "flex"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadedAvatar/* UploadedAvatar */.D, {
                        sx: {
                            height: 32,
                            width: 32
                        },
                        image: user === null || user === void 0 ? void 0 : user.avatar
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        sx: {
                            pl: 2,
                            display: {
                                xs: "none",
                                sm: "block"
                            }
                        },
                        children: user === null || user === void 0 ? void 0 : user.email
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Popover/* default */.ZP, {
                anchorEl: anchorRef.current,
                anchorOrigin: {
                    horizontal: "center",
                    vertical: "bottom"
                },
                keepMounted: true,
                onClose: handleClose,
                open: open,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(List/* default */.Z, {
                    dense: true,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem/* default */.ZP, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                sx: {
                                    width: "100%",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "caption",
                                        children: user === null || user === void 0 ? void 0 : user.name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ThemeSwitcher, {})
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem/* default */.ZP, {
                            disablePadding: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItemButton/* default */.Z, {
                                onClick: function() {
                                    router.push(routes/* ROUTES.PROFILE_USER */.Z.PROFILE_USER);
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemIcon/* default */.Z, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ManageAccounts/* default */.Z, {})
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                                        primary: "User Profile"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem/* default */.ZP, {
                            disablePadding: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ListItemButton/* default */.Z, {
                                onClick: handleLogout,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemIcon/* default */.Z, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Logout/* default */.Z, {})
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItemText/* default */.Z, {
                                        primary: "Logout"
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    }));
};
/* harmony default export */ var Popover_AccountPopover = (AccountPopover);

;// CONCATENATED MODULE: ./src/hooks/useScript.ts

var useScript = function(url, id) {
    (0,react.useEffect)(function() {
        var script = document.createElement("script");
        script.src = url;
        script.async = true;
        script.type = "text/javascript";
        script.defer = true;
        if (id) {
            script.id = id;
        }
        document.body.appendChild(script);
        return function() {
            document.body.removeChild(script);
        };
    }, [
        url,
        id
    ]);
};
/* harmony default export */ var hooks_useScript = (useScript);

;// CONCATENATED MODULE: ./src/icons/Menu.tsx


var Menu = (0,createSvgIcon/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
        fillRule: "evenodd",
        d: "M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z",
        clipRule: "evenodd"
    })
}), "Menu");
/* harmony default export */ var icons_Menu = (Menu);

;// CONCATENATED MODULE: ./src/components/dashboard/DashboardNavbar.tsx







function DashboardNavbar_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function DashboardNavbar_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            DashboardNavbar_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var DashboardNavbarRoot = (0,styled/* default */.ZP)(AppBar/* default */.Z)(function(param) {
    var theme = param.theme;
    return DashboardNavbar_objectSpread({}, theme.palette.mode === "light" && {
        backgroundColor: theme.palette.primary.main,
        boxShadow: "none",
        color: theme.palette.primary.contrastText
    }, theme.palette.mode === "dark" && {
        backgroundColor: theme.palette.background.paper,
        borderBottom: "1px solid ".concat(theme.palette.divider),
        boxShadow: "none"
    }, {
        zIndex: theme.zIndex.drawer + 100
    });
});
var DashboardNavbar = function(_param) {
    var onSidebarMobileOpen = _param.onSidebarMobileOpen, other = _objectWithoutProperties(_param, [
        "onSidebarMobileOpen"
    ]);
    // Hubspot chat widget
    hooks_useScript("//js.hs-scripts.com/5186921.js", "hs-script-loader");
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        displayPrint: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DashboardNavbarRoot, DashboardNavbar_objectSpread({}, other, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Toolbar/* default */.Z, {
                sx: {
                    minHeight: 64
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                        sx: {
                            display: {
                                lg: "none",
                                xs: "block"
                            }
                        },
                        color: "inherit",
                        onClick: onSidebarMobileOpen,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Menu, {
                            fontSize: "small"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                            alt: "PHI Logo",
                            src: "/logos/phi-logo.svg",
                            height: 42,
                            width: 230
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        sx: {
                            flexGrow: 1,
                            ml: 2
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        sx: {
                            ml: 2
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Popover_AccountPopover, {})
                    })
                ]
            })
        }))
    }));
};
/* harmony default export */ var dashboard_DashboardNavbar = (DashboardNavbar);

// EXTERNAL MODULE: ./node_modules/@mui/material/Divider/Divider.js
var Divider = __webpack_require__(67720);
// EXTERNAL MODULE: ./node_modules/@mui/material/Drawer/Drawer.js
var Drawer = __webpack_require__(19058);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/useTheme.js
var useTheme = __webpack_require__(2734);
// EXTERNAL MODULE: ./node_modules/@prisma/client/index-browser.js
var index_browser = __webpack_require__(70385);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/esm/ArrowBack.js
var ArrowBack = __webpack_require__(94669);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js
var Button = __webpack_require__(69397);
;// CONCATENATED MODULE: ./src/components/dashboard/ViewingCard.tsx










function ViewingCard_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ViewingCard_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ViewingCard_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var ViewingCard = function() {
    var ref5 = (0,useAuth/* default */.Z)(), user = ref5.user, organizationId = ref5.organizationId, switchOrganization = ref5.switchOrganization, roles = ref5.roles;
    var router = (0,next_router.useRouter)();
    var ref1 = (0,useSettings/* default */.Z)(), settings = ref1.settings, saveSettings = ref1.saveSettings;
    var isOrgMember = (user === null || user === void 0 ? void 0 : user.organization_id) === organizationId;
    var ref2 = (0,queries/* useOrganization */.o8)(organizationId), theOrganization = ref2.organization;
    var organization = (0,queries/* useOrganization */.o8)(typeof organizationId === "string" ? organizationId : null).organization;
    var isEnterpriseAdmin = roles.some(function(r) {
        return r.role_id === data_role/* ROLE_IDS.4 */.$[4];
    });
    var clearOrganization = function() {
        var ref;
        switchOrganization((ref = user === null || user === void 0 ? void 0 : user.organization_id) !== null && ref !== void 0 ? ref : null);
        saveSettings(ViewingCard_objectSpread({}, settings, {
            isViewAs: undefined
        }));
        if (roles.some(function(role) {
            return role.role_id === data_role/* ROLE_IDS.0 */.$[0] || role.role_id === data_role/* ROLE_IDS.5 */.$[5];
        })) {
            router.push(routes/* ROUTES.CLIENTS */.Z.CLIENTS);
        } else if (roles.some(function(role) {
            return role.role_id === data_role/* ROLE_IDS.1 */.$[1];
        })) {
            router.push(routes/* ROUTES.COACH_DASHBOARD */.Z.COACH_DASHBOARD);
        } else {
            router.push(routes/* ROUTES.ORGANIZATIONS */.Z.ORGANIZATIONS);
        }
    };
    var ref3, ref4;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            (!isOrgMember || settings.isViewAs) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                startIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowBack/* default */.Z, {}),
                variant: "text",
                onClick: clearOrganization,
                fullWidth: true,
                children: [
                    " ",
                    isEnterpriseAdmin ? "Back to All Organizations" : "Back to All Clients"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    mt: 2,
                    alignItems: "center",
                    backgroundColor: isOrgMember && !settings.isViewAs ? "background.default" : "rgba(245, 137, 73, 0.08)",
                    borderRadius: 1,
                    display: "flex",
                    overflow: "hidden",
                    border: isOrgMember && !settings.isViewAs ? "none" : "1px solid",
                    borderColor: "secondary.main",
                    p: 2
                },
                children: isOrgMember || settings.isViewAs && user ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    sx: {
                        ml: 2
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            color: "textPrimary",
                            variant: "subtitle1",
                            children: (ref3 = theOrganization === null || theOrganization === void 0 ? void 0 : theOrganization.name) !== null && ref3 !== void 0 ? ref3 : "Loading..."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            color: "textPrimary",
                            variant: "subtitle2",
                            children: user.name
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            color: "textSecondary",
                            variant: "body2",
                            style: {
                                overflowWrap: "anywhere"
                            },
                            children: user.email
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    sx: {
                        ml: 2
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            color: "textPrimary",
                            variant: "subtitle2",
                            children: "Viewing Client:"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            color: "textSecondary",
                            variant: "body2",
                            children: (ref4 = organization === null || organization === void 0 ? void 0 : organization.name) !== null && ref4 !== void 0 ? ref4 : "Loading..."
                        })
                    ]
                })
            })
        ]
    }));
};

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
;// CONCATENATED MODULE: ./src/components/NavItem.tsx




function NavItem_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function NavItem_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            NavItem_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var NavItem = function(param) {
    var _active = param.active, active = _active === void 0 ? false : _active, icon = param.icon, path = param.path, title = param.title, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(ListItem/* default */.ZP, {
        disableGutters: true,
        sx: {
            display: "flex",
            py: 0
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
            href: path !== null && path !== void 0 ? path : "",
            passHref: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                startIcon: icon,
                fullWidth: true,
                disabled: disabled,
                sx: NavItem_objectSpread({
                    fontSize: "0.8rem",
                    color: "text.secondary",
                    justifyContent: "flex-start",
                    pl: 2,
                    pr: 1,
                    py: 1.5,
                    mb: 1,
                    textAlign: "left",
                    textTransform: "none",
                    borderRadius: 4,
                    "& svg": {
                        color: "secondary.main"
                    }
                }, active && {
                    color: "text.primary",
                    fontWeight: "fontWeightBold",
                    backgroundColor: "background.selected"
                }),
                variant: "text",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    sx: {
                        flexGrow: 1
                    },
                    children: title
                })
            })
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@mui/material/ListSubheader/ListSubheader.js
var ListSubheader = __webpack_require__(17075);
;// CONCATENATED MODULE: ./src/components/NavSection.tsx




var isActive = function(pathname, itemPath) {
    if (!itemPath) {
        return false;
    }
    return "".concat(pathname, "/").startsWith("".concat(itemPath, "/"));
};
var NavSection = function(param) {
    var items = param.items, pathname = param.pathname, title = param.title, disabledKeys = param.disabledKeys;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(List/* default */.Z, {
        subheader: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListSubheader/* default */.Z, {
            disableGutters: true,
            disableSticky: true,
            sx: {
                color: "text.primary",
                fontSize: "0.75rem",
                lineHeight: 2.5,
                fontWeight: 700,
                textTransform: "uppercase"
            },
            children: title
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(List/* default */.Z, {
            disablePadding: true,
            children: items.map(function(item) {
                /*#__PURE__*/ return (0,jsx_runtime.jsx)(NavItem, {
                    active: isActive(pathname, item.path),
                    icon: item.icon,
                    path: item.path,
                    title: item.title,
                    disabled: disabledKeys === null || disabledKeys === void 0 ? void 0 : disabledKeys.includes(item.key)
                }, item.key);
            })
        })
    });
};
var NavCollection = function(param) {
    var sidebarRoutes = param.sidebarRoutes, visibleKeys = param.visibleKeys, pathname = param.pathname, isViewingAs = param.isViewingAs, disabledKeys = param.disabledKeys;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: sidebarRoutes.map(function(section) {
            var items = section.items.filter(function(item) {
                return isViewingAs ? item.showViewingAs : visibleKeys.includes(item.key);
            });
            if (items.length === 0) {
                return null;
            }
            return(/*#__PURE__*/ (0,jsx_runtime.jsx)(NavSection, {
                pathname: pathname,
                items: items,
                title: section.title,
                disabledKeys: disabledKeys
            }, section.title));
        })
    });
};

// EXTERNAL MODULE: ./src/components/Scrollbar.tsx
var Scrollbar = __webpack_require__(84855);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/esm/Dashboard.js
var Dashboard = __webpack_require__(84433);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/esm/Warning.js
var Warning = __webpack_require__(36195);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/esm/Assessment.js
var Assessment = __webpack_require__(96348);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/esm/School.js
var School = __webpack_require__(30990);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/esm/Policy.js
var Policy = __webpack_require__(22646);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/esm/AccountCircle.js
var AccountCircle = __webpack_require__(91988);
;// CONCATENATED MODULE: ./src/icons/ChatAlt.tsx


var ChatAlt = (0,createSvgIcon/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
        fillRule: "evenodd",
        d: "M18 5v8a2 2 0 01-2 2h-5l-5 4v-4H4a2 2 0 01-2-2V5a2 2 0 012-2h12a2 2 0 012 2zM7 8H5v2h2V8zm2 0h2v2H9V8zm6 0h-2v2h2V8z",
        clipRule: "evenodd"
    })
}), "ChatAlt");
/* harmony default export */ var icons_ChatAlt = (ChatAlt);

;// CONCATENATED MODULE: ./src/icons/DocumentDuplicate.tsx


var DocumentDuplicate = (0,createSvgIcon/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    children: [
        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M9 2C8.46957 2 7.96086 2.21071 7.58579 2.58579C7.21071 2.96086 7 3.46957 7 4V12C7 12.5304 7.21071 13.0391 7.58579 13.4142C7.96086 13.7893 8.46957 14 9 14H15C15.5304 14 16.0391 13.7893 16.4142 13.4142C16.7893 13.0391 17 12.5304 17 12V6.414C16.9999 5.88361 16.7891 5.37499 16.414 5L14 2.586C13.625 2.2109 13.1164 2.00011 12.586 2H9Z",
            fillOpacity: "0.86"
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M3 8C3 7.46957 3.21071 6.96086 3.58579 6.58579C3.96086 6.21071 4.46957 6 5 6V16H13C13 16.5304 12.7893 17.0391 12.4142 17.4142C12.0391 17.7893 11.5304 18 11 18H5C4.46957 18 3.96086 17.7893 3.58579 17.4142C3.21071 17.0391 3 16.5304 3 16V8Z",
            fillOpacity: "0.86"
        })
    ]
}), "DocumentDuplicate");
/* harmony default export */ var icons_DocumentDuplicate = (DocumentDuplicate);

;// CONCATENATED MODULE: ./src/icons/DocumentSearch.tsx


var DocumentSearch = (0,createSvgIcon/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    children: [
        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M4 4C4 3.46957 4.21071 2.96086 4.58579 2.58579C4.96086 2.21071 5.46957 2 6 2H10.586C11.1164 2.00011 11.625 2.2109 12 2.586L15.414 6C15.7891 6.37499 15.9999 6.88361 16 7.414V16C16 16.5304 15.7893 17.0391 15.4142 17.4142C15.0391 17.7893 14.5304 18 14 18H12.472C13.4938 16.8569 14.0393 15.366 13.9964 13.8334C13.9535 12.3008 13.3255 10.8428 12.2414 9.75864C11.1572 8.6745 9.69917 8.04652 8.16657 8.00363C6.63396 7.96074 5.14308 8.50619 4 9.528V4Z",
            fillOpacity: "0.86"
        }),
        /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8.0002 10C7.29487 9.9999 6.60204 10.1863 5.99199 10.5403C5.38193 10.8943 4.87633 11.4034 4.52645 12.0158C4.17657 12.6283 3.99485 13.3223 3.99973 14.0276C4.0046 14.733 4.19589 15.4245 4.5542 16.032L3.2932 17.292C3.20029 17.3848 3.12658 17.4951 3.07627 17.6164C3.02596 17.7377 3.00005 17.8678 3 17.9991C2.99995 18.1305 3.02578 18.2606 3.076 18.3819C3.12622 18.5033 3.19986 18.6136 3.2927 18.7065C3.38555 18.7994 3.49578 18.8731 3.61712 18.9234C3.73845 18.9737 3.8685 18.9997 3.99985 18.9997C4.1312 18.9997 4.26127 18.9739 4.38264 18.9237C4.50401 18.8735 4.61429 18.7998 4.7072 18.707L5.9682 17.446C6.49805 17.7583 7.09277 17.9442 7.70614 17.9892C8.31951 18.0343 8.93502 17.9373 9.50482 17.7058C10.0746 17.4743 10.5834 17.1146 10.9915 16.6545C11.3996 16.1944 11.6962 15.6464 11.8581 15.0531C12.02 14.4598 12.043 13.8371 11.9251 13.2335C11.8072 12.6298 11.5518 12.0615 11.1785 11.5727C10.8053 11.0838 10.3244 10.6876 9.77317 10.4149C9.22194 10.1421 8.61523 10.0001 8.0002 10ZM6.0002 14C6.0002 13.4696 6.21092 12.9609 6.58599 12.5858C6.96106 12.2107 7.46977 12 8.0002 12C8.53064 12 9.03934 12.2107 9.41442 12.5858C9.78949 12.9609 10.0002 13.4696 10.0002 14C10.0002 14.5304 9.78949 15.0391 9.41442 15.4142C9.03934 15.7893 8.53064 16 8.0002 16C7.46977 16 6.96106 15.7893 6.58599 15.4142C6.21092 15.0391 6.0002 14.5304 6.0002 14Z",
            fillOpacity: "0.86"
        })
    ]
}), "DocumentSearch");
/* harmony default export */ var icons_DocumentSearch = (DocumentSearch);

;// CONCATENATED MODULE: ./src/icons/Key.tsx


var Key = (0,createSvgIcon/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16 6.00001C16.0003 6.93719 15.781 7.86139 15.3598 8.69856C14.9386 9.53573 14.3271 10.2626 13.5744 10.8209C12.8216 11.3792 11.9486 11.7534 11.0252 11.9135C10.1018 12.0737 9.15376 12.0153 8.257 11.743L8 12L7 13L6 14H4V16H0V12L4.257 7.74301C4.00745 6.91803 3.93857 6.04896 4.05504 5.19496C4.17152 4.34096 4.47062 3.52208 4.93199 2.79406C5.39336 2.06604 6.00616 1.44596 6.72869 0.976034C7.45122 0.506108 8.26652 0.197365 9.11908 0.0708197C9.97164 -0.0557254 10.8415 0.00289777 11.6693 0.242699C12.4972 0.482501 13.2637 0.897851 13.9166 1.46048C14.5696 2.02311 15.0936 2.71981 15.4531 3.50315C15.8127 4.2865 15.9992 5.13811 16 6.00001ZM10 2.00001C9.73478 2.00001 9.48043 2.10537 9.29289 2.29291C9.10536 2.48044 9 2.7348 9 3.00001C9 3.26523 9.10536 3.51958 9.29289 3.70712C9.48043 3.89466 9.73478 4.00001 10 4.00001C10.5304 4.00001 11.0391 4.21073 11.4142 4.5858C11.7893 4.96087 12 5.46958 12 6.00001C12 6.26523 12.1054 6.51959 12.2929 6.70712C12.4804 6.89466 12.7348 7.00001 13 7.00001C13.2652 7.00001 13.5196 6.89466 13.7071 6.70712C13.8946 6.51959 14 6.26523 14 6.00001C14 4.93915 13.5786 3.92173 12.8284 3.17159C12.0783 2.42144 11.0609 2.00001 10 2.00001Z"
    })
}), "Key");
/* harmony default export */ var icons_Key = (Key);

;// CONCATENATED MODULE: ./src/icons/Lock.tsx


var Lock = (0,createSvgIcon/* default */.Z)(/*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
        fillRule: "evenodd",
        d: "M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z",
        clipRule: "evenodd"
    })
}), "Lock");
/* harmony default export */ var icons_Lock = (Lock);

// EXTERNAL MODULE: ./src/icons/SpeakerPhone.tsx
var SpeakerPhone = __webpack_require__(43436);
;// CONCATENATED MODULE: ./src/constants/sidebar-routes.tsx









var sidebarRoutes = [
    {
        title: "",
        items: [
            {
                title: "Admin Dashboard",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Key, {
                    fontSize: "small"
                }),
                key: "admin_dashboard",
                path: routes/* ROUTES.ADMIN_DASHBOARD */.Z.ADMIN_DASHBOARD
            },
            {
                title: "Coach Dashboard",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Key, {
                    fontSize: "small"
                }),
                key: "coach_dashboard",
                path: routes/* ROUTES.COACH_DASHBOARD */.Z.COACH_DASHBOARD
            },
            {
                title: "Dashboard",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Dashboard/* default */.Z, {
                    fontSize: "small"
                }),
                key: "dashboard",
                path: routes/* ROUTES.DASHBOARD */.Z.DASHBOARD,
                showViewingAs: true
            },
            {
                title: "Risk Registry",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Warning/* default */.Z, {
                    fontSize: "small"
                }),
                key: "risk_registry",
                path: routes/* ROUTES.RISK_REGISTRY */.Z.RISK_REGISTRY,
                showViewingAs: true
            },
            {
                title: "Assessments",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Assessment/* default */.Z, {
                    fontSize: "small"
                }),
                key: "assessments",
                path: routes/* ROUTES.ASSESSMENTS */.Z.ASSESSMENTS,
                showViewingAs: true
            },
            {
                title: "Training",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(School/* default */.Z, {
                    fontSize: "small"
                }),
                key: "training",
                path: routes/* ROUTES.TRAINING */.Z.TRAINING,
                showViewingAs: true
            },
            {
                title: "Policy Manager",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Policy/* default */.Z, {
                    fontSize: "small"
                }),
                key: "policy_manager",
                path: routes/* ROUTES.POLICIES */.Z.POLICIES,
                showViewingAs: true
            },
            {
                title: "Document Library",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_DocumentSearch, {
                    fontSize: "small"
                }),
                key: "document_library",
                path: routes/* ROUTES.DOCUMENTS */.Z.DOCUMENTS,
                showViewingAs: true
            },
            {
                title: "Coach",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SpeakerPhone/* default */.Z, {
                    fontSize: "small"
                }),
                key: "coach",
                path: routes/* ROUTES.COACH */.Z.COACH,
                showViewingAs: true
            },
            {
                title: "Chat",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_ChatAlt, {
                    fontSize: "small"
                }),
                key: "chat",
                path: routes/* ROUTES.CHAT */.Z.CHAT
            },
            {
                title: "Clients",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountCircle/* default */.Z, {
                    fontSize: "small"
                }),
                key: "clients",
                path: routes/* ROUTES.CLIENTS */.Z.CLIENTS
            },
            {
                title: "Organizations",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountCircle/* default */.Z, {
                    fontSize: "small"
                }),
                key: "organizations",
                path: routes/* ROUTES.ORGANIZATIONS */.Z.ORGANIZATIONS
            },
            {
                title: "Resources",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_DocumentDuplicate, {
                    fontSize: "small"
                }),
                key: "resources",
                path: routes/* ROUTES.RESOURCES */.Z.RESOURCES
            },
            {
                title: "Incident Management",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Policy/* default */.Z, {
                    fontSize: "small"
                }),
                key: "incident_management",
                path: routes/* ROUTES.INCIDENT_MANAGEMENT */.Z.INCIDENT_MANAGEMENT,
                showViewingAs: "true" === "true"
            },
            {
                title: "Privacy Community",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Lock, {
                    fontSize: "small"
                }),
                key: "privacy_community",
                path: routes/* ROUTES.COMMUNITY */.Z.COMMUNITY
            }, 
        ]
    },
    {
        title: "Admin",
        items: [
            {
                title: "Policy Templates",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Key, {
                    fontSize: "small"
                }),
                key: "policy_templates",
                path: routes/* ROUTES.POLICY_TEMPLATES */.Z.POLICY_TEMPLATES
            },
            {
                title: "Assessment Templates",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Key, {
                    fontSize: "small"
                }),
                key: "assessment_templates",
                path: routes/* ROUTES.ASSESSMENT_TEMPLATES */.Z.ASSESSMENT_TEMPLATES
            },
            {
                title: "PHI Settings",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Key, {
                    fontSize: "small"
                }),
                key: "phi_settings",
                path: routes/* ROUTES.PHI_SETTINGS */.Z.PHI_SETTINGS
            }, 
        ]
    }, 
];
var enterpriseSidebarRoutes = function(organization_name) {
    return [
        {
            title: "Enterprise",
            items: [
                {
                    title: "Admin Dashboard",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Key, {
                        fontSize: "small"
                    }),
                    key: "admin_dashboard",
                    path: routes/* ROUTES.ADMIN_DASHBOARD */.Z.ADMIN_DASHBOARD
                },
                {
                    title: "Coach Dashboard",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Key, {
                        fontSize: "small"
                    }),
                    key: "coach_dashboard",
                    path: routes/* ROUTES.COACH_DASHBOARD */.Z.COACH_DASHBOARD
                },
                {
                    title: "Dashboard",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Dashboard/* default */.Z, {
                        fontSize: "small"
                    }),
                    key: "dashboard",
                    path: routes/* ROUTES.DASHBOARD */.Z.DASHBOARD,
                    showViewingAs: true
                },
                {
                    title: "Risk Registry",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Warning/* default */.Z, {
                        fontSize: "small"
                    }),
                    key: "risk_registry",
                    path: routes/* ROUTES.RISK_REGISTRY */.Z.RISK_REGISTRY,
                    showViewingAs: true
                },
                {
                    title: "Assessments",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Assessment/* default */.Z, {
                        fontSize: "small"
                    }),
                    key: "assessments",
                    path: routes/* ROUTES.ASSESSMENTS */.Z.ASSESSMENTS,
                    showViewingAs: true
                },
                {
                    title: "Chat",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_ChatAlt, {
                        fontSize: "small"
                    }),
                    key: "chat",
                    path: routes/* ROUTES.CHAT */.Z.CHAT
                },
                {
                    title: "Clients",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountCircle/* default */.Z, {
                        fontSize: "small"
                    }),
                    key: "clients",
                    path: routes/* ROUTES.CLIENTS */.Z.CLIENTS
                },
                {
                    title: "Organizations",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountCircle/* default */.Z, {
                        fontSize: "small"
                    }),
                    key: "organizations",
                    path: routes/* ROUTES.ORGANIZATIONS */.Z.ORGANIZATIONS
                },
                {
                    title: "Resources",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_DocumentDuplicate, {
                        fontSize: "small"
                    }),
                    key: "resources",
                    path: routes/* ROUTES.RESOURCES */.Z.RESOURCES
                },
                {
                    title: "Incident Management",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Policy/* default */.Z, {
                        fontSize: "small"
                    }),
                    key: "incident_management",
                    path: routes/* ROUTES.INCIDENT_MANAGEMENT */.Z.INCIDENT_MANAGEMENT
                },
                {
                    title: "Privacy Community",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Lock, {
                        fontSize: "small"
                    }),
                    key: "privacy_community",
                    path: routes/* ROUTES.COMMUNITY */.Z.COMMUNITY
                }, 
            ]
        },
        {
            title: organization_name,
            items: [
                {
                    title: "Training",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(School/* default */.Z, {
                        fontSize: "small"
                    }),
                    key: "training",
                    path: routes/* ROUTES.TRAINING */.Z.TRAINING,
                    showViewingAs: true
                },
                {
                    title: "Policy Manager",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Policy/* default */.Z, {
                        fontSize: "small"
                    }),
                    key: "policy_manager",
                    path: routes/* ROUTES.POLICIES */.Z.POLICIES,
                    showViewingAs: true
                },
                {
                    title: "Document Library",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_DocumentSearch, {
                        fontSize: "small"
                    }),
                    key: "document_library",
                    path: routes/* ROUTES.DOCUMENTS */.Z.DOCUMENTS,
                    showViewingAs: true
                },
                {
                    title: "Coach",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SpeakerPhone/* default */.Z, {
                        fontSize: "small"
                    }),
                    key: "coach",
                    path: routes/* ROUTES.COACH */.Z.COACH,
                    showViewingAs: true
                }, 
            ]
        },
        {
            title: "Admin",
            items: [
                {
                    title: "Assessment Templates",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Key, {
                        fontSize: "small"
                    }),
                    key: "assessment_templates",
                    path: routes/* ROUTES.ASSESSMENT_TEMPLATES */.Z.ASSESSMENT_TEMPLATES
                },
                {
                    title: "PHI Settings",
                    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Key, {
                        fontSize: "small"
                    }),
                    key: "phi_settings",
                    path: routes/* ROUTES.PHI_SETTINGS */.Z.PHI_SETTINGS
                }, 
            ]
        }, 
    ];
};
var sidebarRouteOrganized = {
    titleTop: "Pinned Settings",
    title: "Organization Settings",
    icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Key, {
        fontSize: "small"
    }),
    key: "org_settings",
    path: routes/* ROUTES.PROFILE_ORGANIZATION */.Z.PROFILE_ORGANIZATION
};
var auditorSidebarRoutes = [
    {
        title: "Auditor",
        items: [
            {
                title: "Clients",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountCircle/* default */.Z, {
                    fontSize: "small"
                }),
                key: "clients",
                path: routes/* ROUTES.CLIENTS */.Z.CLIENTS
            }, 
        ]
    }, 
];
var auditorViewAsSidebarRoutes = [
    {
        title: "Auditor",
        items: [
            {
                title: "Risk Registry",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Warning/* default */.Z, {
                    fontSize: "small"
                }),
                key: "risk_registry",
                path: routes/* ROUTES.RISK_REGISTRY */.Z.RISK_REGISTRY,
                showViewingAs: true
            },
            {
                title: "Assessments",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Assessment/* default */.Z, {
                    fontSize: "small"
                }),
                key: "assessments",
                path: routes/* ROUTES.ASSESSMENTS */.Z.ASSESSMENTS,
                showViewingAs: true
            },
            {
                title: "Policy Manager",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Policy/* default */.Z, {
                    fontSize: "small"
                }),
                key: "policy_manager",
                path: routes/* ROUTES.POLICIES */.Z.POLICIES,
                showViewingAs: true
            },
            {
                title: "Document Library",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_DocumentSearch, {
                    fontSize: "small"
                }),
                key: "document_library",
                path: routes/* ROUTES.DOCUMENTS */.Z.DOCUMENTS,
                showViewingAs: true
            },
            {
                title: "Clients",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(AccountCircle/* default */.Z, {
                    fontSize: "small"
                }),
                key: "clients",
                path: routes/* ROUTES.CLIENTS */.Z.CLIENTS
            }, 
        ]
    }, 
];

// EXTERNAL MODULE: ./src/types/api/index.ts + 5 modules
var api = __webpack_require__(20411);
;// CONCATENATED MODULE: ./src/components/dashboard/DashboardSidebar.tsx

















var DashboardSidebar = function(props) {
    var onMobileClose = props.onMobileClose, openMobile = props.openMobile;
    var ref1 = (0,useAuth/* default */.Z)(), menus = ref1.menus, organizationId = ref1.organizationId, user = ref1.user, roles = ref1.roles;
    var router = (0,next_router.useRouter)();
    var theme = (0,useTheme/* default */.Z)();
    var isPhiAdmin = roles.some(function(role) {
        return role.role_name === "PHI Admin";
    });
    var settings = (0,useSettings/* default */.Z)().settings;
    var organization = (0,queries/* useOrganization */.o8)(organizationId).organization;
    var subscriptionPlans = (0,queries/* useSubscriptionPlans */.Xp)(organizationId).subscriptionPlans;
    var isActive = function(pathname, itemPath) {
        if (!itemPath) {
            return false;
        }
        return "".concat(pathname, "/").startsWith("".concat(itemPath, "/"));
    };
    var seeOrgSettings = roles.some(function(elem) {
        return elem.role_id === data_role/* ROLE_IDS.2 */.$[2];
    });
    var isEnterpriseAdmin = roles.some(function(role) {
        return role.role_id === data_role/* ROLE_IDS.4 */.$[4];
    });
    var isAuditor = roles.some(function(role) {
        return role.role_id === data_role/* ROLE_IDS.5 */.$[5];
    });
    var roleSidebarRoutes = function() {
        if (isEnterpriseAdmin && !settings.isViewAs) {
            var ref;
            return enterpriseSidebarRoutes((ref = organization === null || organization === void 0 ? void 0 : organization.name) !== null && ref !== void 0 ? ref : "Loading...");
        }
        if (isAuditor) {
            if (settings.isViewAs) return auditorViewAsSidebarRoutes;
            return auditorSidebarRoutes;
        }
        return sidebarRoutes;
    };
    var isIncidentManagementPlan = react.useMemo(function() {
        if (!subscriptionPlans) return false;
        var incidentManagementPlan = subscriptionPlans.items.find(function(plan) {
            return plan.product.name === api/* STRIPE_INCIDENT_MANAGEMENT_PLAN_NAME */.uQ;
        });
        return Boolean(incidentManagementPlan);
    }, [
        subscriptionPlans
    ]);
    var hasIncidentManagementAddon = react.useMemo(function() {
        if (!subscriptionPlans) return false;
        var imAddon = subscriptionPlans.items.find(function(plan) {
            return plan.product.name === "Incident Management Add-On" && plan.quantity > 0;
        });
        var imAddonIncludedPlan = subscriptionPlans.items.find(function(plan) {
            return plan.product.name === api/* STRIPE_INCIDENT_MANAGEMENT_PLAN_NAME */.uQ || plan.product.name === "VPO";
        });
        return Boolean(imAddon) || Boolean(imAddonIncludedPlan);
    }, [
        subscriptionPlans
    ]);
    var disabledKeys = react.useMemo(function() {
        var ref, ref2;
        if (!subscriptionPlans) return [
            index_browser.MenuId.training,
            index_browser.MenuId.policy_manager,
            index_browser.MenuId.incident_management, 
        ];
        var keys = [];
        var ref3, ref4;
        var trainingSeats = ((ref3 = (ref = subscriptionPlans.items.find(function(plan) {
            return plan.product.name === "Training Seat";
        })) === null || ref === void 0 ? void 0 : ref.quantity) !== null && ref3 !== void 0 ? ref3 : 0) + ((ref4 = (ref2 = subscriptionPlans.items[0].db_product) === null || ref2 === void 0 ? void 0 : ref2.training_seats) !== null && ref4 !== void 0 ? ref4 : 0);
        if (trainingSeats === 0) {
            keys.push(index_browser.MenuId.training, index_browser.MenuId.policy_manager);
        }
        if (!hasIncidentManagementAddon && !isIncidentManagementPlan) {
            keys.push(index_browser.MenuId.incident_management);
        }
        return keys;
    }, [
        subscriptionPlans,
        hasIncidentManagementAddon,
        isIncidentManagementPlan
    ]);
    var noIMOnProductionMenus = react.useMemo(function() {
        var modifiedMenus = menus;
        if (!hasIncidentManagementAddon && !isIncidentManagementPlan) {
            modifiedMenus = modifiedMenus.filter(function(menu_id) {
                return menu_id !== "incident_management";
            });
        }
        if (isIncidentManagementPlan) {
            modifiedMenus = modifiedMenus.filter(function(menu_id) {
                return menu_id === "incident_management";
            });
        }
        if (false) {}
        if (isPhiAdmin && (user === null || user === void 0 ? void 0 : user.organization_id) === organizationId) {
            modifiedMenus = modifiedMenus.filter(function(menu_id) {
                return menu_id !== "incident_management";
            });
        }
        return modifiedMenus;
    }, [
        menus,
        isPhiAdmin,
        user,
        organizationId,
        hasIncidentManagementAddon,
        isIncidentManagementPlan, 
    ]);
    var content = /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        sx: {
            display: "flex",
            flexDirection: "column",
            height: "100%"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    display: "flex",
                    flexDirection: "column",
                    height: "calc(100% - 60px)"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Scrollbar/* default */.Z, {
                    options: {
                        suppressScrollX: true
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            sx: {
                                justifyContent: "center",
                                p: 2,
                                display: {
                                    lg: "none",
                                    xs: "flex"
                                }
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                alt: "PHI Logo",
                                src: theme.palette.mode === "light" ? "/logos/phi-logo-dark.svg" : "/logos/phi-logo.svg",
                                height: 42,
                                width: 230
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            sx: {
                                p: 2
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ViewingCard, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            sx: {
                                p: 2
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavCollection, {
                                visibleKeys: noIMOnProductionMenus,
                                sidebarRoutes: roleSidebarRoutes(),
                                pathname: router.pathname,
                                isViewingAs: (user === null || user === void 0 ? void 0 : user.organization_id) !== organizationId,
                                disabledKeys: disabledKeys
                            })
                        })
                    ]
                })
            }),
            seeOrgSettings && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    position: "absolute",
                    bottom: 0,
                    left: 15
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItem, {
                    active: isActive(router.pathname, sidebarRouteOrganized.path),
                    icon: sidebarRouteOrganized.icon,
                    path: sidebarRouteOrganized.path,
                    title: sidebarRouteOrganized.title
                }, sidebarRouteOrganized.key)
            }),
            isPhiAdmin && settings.isViewAs !== undefined && settings.isViewAs !== (user === null || user === void 0 ? void 0 : user.organization_id) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    position: "absolute",
                    bottom: 0,
                    left: 15,
                    width: "90%"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NavItem, {
                    active: isActive(router.pathname, sidebarRouteOrganized.path),
                    icon: sidebarRouteOrganized.icon,
                    path: sidebarRouteOrganized.path,
                    title: sidebarRouteOrganized.title
                }, sidebarRouteOrganized.key)
            })
        ]
    });
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Drawer/* default */.ZP, {
                anchor: "left",
                onClose: onMobileClose,
                open: openMobile,
                PaperProps: {
                    sx: {
                        backgroundColor: "background.paper",
                        width: 280
                    }
                },
                sx: {
                    display: {
                        lg: "none",
                        xs: "block"
                    }
                },
                variant: "temporary",
                children: content
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Drawer/* default */.ZP, {
                anchor: "left",
                open: true,
                PaperProps: {
                    sx: {
                        backgroundColor: "background.paper",
                        height: "calc(100% - 64px) !important",
                        top: "64px !Important",
                        width: 280
                    }
                },
                sx: {
                    display: {
                        lg: "block",
                        xs: "none"
                    }
                },
                variant: "persistent",
                children: content
            })
        ]
    }));
};
/* harmony default export */ var dashboard_DashboardSidebar = (DashboardSidebar);

// EXTERNAL MODULE: ./node_modules/@mui/lab/LoadingButton/LoadingButton.js + 1 modules
var LoadingButton = __webpack_require__(31812);
// EXTERNAL MODULE: ./node_modules/@mui/material/Card/Card.js
var Card = __webpack_require__(62623);
// EXTERNAL MODULE: ./node_modules/@mui/material/CardHeader/CardHeader.js
var CardHeader = __webpack_require__(86867);
// EXTERNAL MODULE: ./node_modules/@mui/material/CardContent/CardContent.js
var CardContent = __webpack_require__(28492);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/components/SkeletonLoader.tsx
var SkeletonLoader = __webpack_require__(63016);
// EXTERNAL MODULE: ./src/backend/constants/add-on-ids.ts
var add_on_ids = __webpack_require__(14191);
// EXTERNAL MODULE: ./src/requests/queries/useAddons.ts
var useAddons = __webpack_require__(9904);
;// CONCATENATED MODULE: ./src/components/ExtraPaymentSplashScreen.tsx















function ExtraPaymentSplashScreen_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function ExtraPaymentSplashScreen_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                ExtraPaymentSplashScreen_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                ExtraPaymentSplashScreen_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var ExtraPaymentSplashScreen = function(param) {
    var logout = param.logout;
    var router = (0,next_router.useRouter)();
    var enqueueSnackbar = (0,notistack_esm/* useSnackbar */.Ds)().enqueueSnackbar;
    var organizationId = (0,useAuth/* default */.Z)().organizationId;
    var ref4 = (0,dist/* default */.ZP)(organizationId ? "organization/".concat(organizationId, "/plan") : null), planData = ref4.data, planDataError = ref4.error;
    var ref1 = (0,useAddons/* useAddons */.D)(), addons = ref1.addons, isAddonsLoading = ref1.isAddonsLoading;
    var ref2 = (0,queries/* useSubscriptionPlansIncludeScheduled */.ll)(organizationId), subscriptionPlans = ref2.subscriptionPlans, isSubscriptionPlansLoading = ref2.isSubscriptionPlansLoading;
    var scheduledSubscriptionValues = (0,react.useMemo)(function() {
        if (!subscriptionPlans || !addons) return {};
        var _scheduled_items;
        var subscriptionItems = (_scheduled_items = subscriptionPlans.scheduled_items) !== null && _scheduled_items !== void 0 ? _scheduled_items : subscriptionPlans.items;
        return subscriptionItems.reduce(function(prev, curr) {
            var ref;
            switch(curr.product.id){
                case (ref = addons.find(function(addOn) {
                    return addOn.addon_id === add_on_ids/* ADDON_IDS.phiShield */.n.phiShield;
                })) === null || ref === void 0 ? void 0 : ref.stripe_product_id:
                    prev.phiShieldLevel = curr.quantity > 0 ? "phi_shield" : "";
                    prev.phiShieldSeats = curr.quantity;
                    break;
                default:
            }
            return prev;
        }, {
            phiShieldLevel: ""
        });
    }, [
        addons,
        subscriptionPlans
    ]);
    var getPlanUpgradeData = function(pendingPayment, pd, sv) {
        var _phiShieldLevel;
        var obj = {
            old_plan_id: pd.id,
            coaching_hours: pendingPayment.coaching_hours,
            training_seats: pendingPayment.training_seats,
            old_phi_shield_level: (_phiShieldLevel = sv.phiShieldLevel) !== null && _phiShieldLevel !== void 0 ? _phiShieldLevel : "",
            phi_shield_level: pendingPayment.phi_shield_level,
            phi_shield_seats: pendingPayment.phi_shield_seats,
            upgrading: true,
            due_now: pendingPayment.due_now,
            im_addon: pendingPayment.im_addon,
            soc2_type1: pendingPayment.soc2_type1_expiry ? true : undefined,
            soc2_type2: pendingPayment.soc2_type2_expiry ? true : undefined,
            soc2_assessment: pendingPayment.soc2_assessment_expiry ? true : undefined,
            pending_payment_id: pendingPayment.pending_payment_id
        };
        return obj;
    };
    var getData = function(pendingPayment) {
        var obj = {
            non_recurring_hours: pendingPayment.non_recurring_hours,
            training_seats: pendingPayment.training_seats,
            pending_payment_id: pendingPayment.pending_payment_id,
            old_plan_id: pendingPayment.plan_id
        };
        if (pendingPayment.training_seats > 0 && pendingPayment.non_recurring_hours === 0) {
            // @ts-expect-error TS gets confused about adding new entries to object
            obj.upgrading = "true";
            // @ts-expect-error TS gets confused about adding new entries to object
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            obj.due_now = pendingPayment.due_now;
        }
        return obj;
    };
    var loadingUpgradeData = isAddonsLoading || isSubscriptionPlansLoading || !planDataError && !planData;
    var ref3 = (0,queries/* usePendingPaymentForOrg */.bM)(organizationId), pendingPayment1 = ref3.pendingPayment, isPendingPaymentLoading = ref3.isPendingPaymentLoading;
    var handleLogout = function() {
        var _ref = ExtraPaymentSplashScreen_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return logout();
                    case 3:
                        router.push(routes/* ROUTES.AUTH_LOGIN */.Z.AUTH_LOGIN);
                        _ctx.next = 10;
                        break;
                    case 6:
                        _ctx.prev = 6;
                        _ctx.t0 = _ctx["catch"](0);
                        console.error(_ctx.t0);
                        enqueueSnackbar("Unable to logout", {
                            anchorOrigin: {
                                horizontal: "right",
                                vertical: "top"
                            },
                            variant: "error"
                        });
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    6
                ]
            ]);
        }));
        return function handleLogout() {
            return _ref.apply(this, arguments);
        };
    }();
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        sx: {
            alignItems: "center",
            backgroundColor: "primary.main",
            display: "flex",
            flexDirection: "column",
            height: "100%",
            justifyContent: "center",
            left: 0,
            p: 3,
            position: "fixed",
            top: 0,
            width: "100%",
            zIndex: 2000
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CardHeader/* default */.Z, {
                    title: "Access Error"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonLoader/* SkeletonLoader */.g, {
                        loading: isPendingPaymentLoading,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            sx: {
                                mt: 2
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    color: "textSecondary",
                                    variant: "subtitle2",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        style: {
                                            padding: 12
                                        },
                                        children: "Payment must be completed to continue."
                                    })
                                }),
                                (pendingPayment1 === null || pendingPayment1 === void 0 ? void 0 : pendingPayment1.admin_plan_upgrade) && loadingUpgradeData && /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingButton/* default */.Z, {
                                    color: "secondary",
                                    fullWidth: true,
                                    size: "large",
                                    variant: "contained",
                                    loading: true,
                                    children: "Go To Payments"
                                }),
                                (pendingPayment1 === null || pendingPayment1 === void 0 ? void 0 : pendingPayment1.admin_plan_upgrade) && !loadingUpgradeData && planData && /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                    href: {
                                        pathname: "".concat(routes/* ROUTES.PAYMENTS */.Z.PAYMENTS, "/").concat(pendingPayment1.plan_id),
                                        query: getPlanUpgradeData(pendingPayment1, planData, scheduledSubscriptionValues)
                                    },
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        color: "secondary",
                                        fullWidth: true,
                                        size: "large",
                                        variant: "contained",
                                        children: "Go To Payments"
                                    })
                                }),
                                pendingPayment1 && !pendingPayment1.admin_plan_upgrade && /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                    href: {
                                        pathname: "".concat(routes/* ROUTES.PAYMENTS */.Z.PAYMENTS, "/").concat(pendingPayment1.plan_id),
                                        query: getData(pendingPayment1)
                                    },
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        color: "secondary",
                                        fullWidth: true,
                                        size: "large",
                                        variant: "contained",
                                        children: "Go To Payments"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                    paddingTop: "16px",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        color: "secondary",
                                        fullWidth: true,
                                        size: "large",
                                        variant: "contained",
                                        onClick: handleLogout,
                                        children: "Log Out"
                                    })
                                })
                            ]
                        })
                    })
                })
            ]
        })
    }));
};
/* harmony default export */ var components_ExtraPaymentSplashScreen = (ExtraPaymentSplashScreen);

// EXTERNAL MODULE: ./src/components/Loading.tsx
var Loading = __webpack_require__(8080);
// EXTERNAL MODULE: ./src/requests/queries/useCoupons.ts
var useCoupons = __webpack_require__(56694);
;// CONCATENATED MODULE: ./src/components/RegisterSplashScreen.tsx












function RegisterSplashScreen_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function RegisterSplashScreen_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                RegisterSplashScreen_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                RegisterSplashScreen_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function RegisterSplashScreen_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function RegisterSplashScreen_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            RegisterSplashScreen_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var RegisterSplashScreen = function(param) {
    var logout = param.logout;
    var ref;
    var router = (0,next_router.useRouter)();
    var enqueueSnackbar = (0,notistack_esm/* useSnackbar */.Ds)().enqueueSnackbar;
    var organizationId = (0,useAuth/* default */.Z)().organizationId;
    var coupons = (0,useCoupons/* useCoupons */.b)().coupons;
    var ref1 = (0,queries/* usePendingPaymentForOrg */.bM)(organizationId), pendingPayment = ref1.pendingPayment, isPendingPaymentLoading = ref1.isPendingPaymentLoading;
    var soc2_addons = react.useMemo(function() {
        if (!pendingPayment) return {};
        return {
            soc2_type1: pendingPayment.soc2_type1_expiry ? true : undefined,
            soc2_type2: pendingPayment.soc2_type2_expiry ? true : undefined,
            soc2_assessment: pendingPayment.soc2_assessment_expiry ? true : undefined
        };
    }, [
        pendingPayment
    ]);
    var handleLogout = function() {
        var _ref = RegisterSplashScreen_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return logout();
                    case 3:
                        router.push(routes/* ROUTES.AUTH_LOGIN */.Z.AUTH_LOGIN);
                        _ctx.next = 10;
                        break;
                    case 6:
                        _ctx.prev = 6;
                        _ctx.t0 = _ctx["catch"](0);
                        console.error(_ctx.t0);
                        enqueueSnackbar("Unable to logout", {
                            anchorOrigin: {
                                horizontal: "right",
                                vertical: "top"
                            },
                            variant: "error"
                        });
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    6
                ]
            ]);
        }));
        return function handleLogout() {
            return _ref.apply(this, arguments);
        };
    }();
    var ref2;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        sx: {
            alignItems: "center",
            backgroundColor: "primary.main",
            display: "flex",
            flexDirection: "column",
            height: "100%",
            justifyContent: "center",
            left: 0,
            p: 3,
            position: "fixed",
            top: 0,
            width: "100%",
            zIndex: 2000
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CardHeader/* default */.Z, {
                    title: "Access Error"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CardContent/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonLoader/* SkeletonLoader */.g, {
                        loading: isPendingPaymentLoading,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            sx: {
                                mt: 2
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    color: "textSecondary",
                                    variant: "subtitle2",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        style: {
                                            padding: 12
                                        },
                                        children: "You must be subscribed to see this route."
                                    })
                                }),
                                pendingPayment ? /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                    href: {
                                        pathname: "".concat(routes/* ROUTES.PAYMENTS */.Z.PAYMENTS, "/").concat(pendingPayment.plan_id),
                                        query: RegisterSplashScreen_objectSpread({
                                            coaching_hours: pendingPayment.coaching_hours,
                                            training_seats: pendingPayment.training_seats,
                                            phi_shield_level: pendingPayment.phi_shield_level,
                                            phi_shield_seats: pendingPayment.phi_shield_level ? pendingPayment.phi_shield_seats : "",
                                            coupon_name: (ref2 = (ref = coupons === null || coupons === void 0 ? void 0 : coupons.find(function(coupon) {
                                                return coupon.id === pendingPayment.coupon;
                                            })) === null || ref === void 0 ? void 0 : ref.name) !== null && ref2 !== void 0 ? ref2 : "",
                                            im_addon: pendingPayment.im_addon
                                        }, soc2_addons)
                                    },
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        color: "secondary",
                                        fullWidth: true,
                                        size: "large",
                                        variant: "contained",
                                        children: "Go To Payments"
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                    href: routes/* ROUTES.PLAN_SELECTION */.Z.PLAN_SELECTION,
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        color: "secondary",
                                        fullWidth: true,
                                        size: "large",
                                        variant: "contained",
                                        children: "Choose Plan"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                    paddingTop: "16px",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        color: "secondary",
                                        fullWidth: true,
                                        size: "large",
                                        variant: "contained",
                                        onClick: handleLogout,
                                        children: "Log Out"
                                    })
                                })
                            ]
                        })
                    })
                })
            ]
        })
    }));
};
/* harmony default export */ var components_RegisterSplashScreen = (RegisterSplashScreen);

;// CONCATENATED MODULE: ./src/components/authentication/AuthenticatedRoute.tsx










var AuthenticatedRoute = function(param) {
    var children = param.children;
    var ref, ref1, ref2;
    var auth = (0,useAuth/* default */.Z)();
    var router = (0,next_router.useRouter)();
    var ref3 = (0,queries/* usePendingPaymentForOrg */.bM)((ref = auth.user) === null || ref === void 0 ? void 0 : ref.organization_id), pendingPayment = ref3.pendingPayment, isPendingPaymentLoading = ref3.isPendingPaymentLoading;
    if (!auth.isInitialized || auth.subscription === "loading" || isPendingPaymentLoading && auth.isAuthenticated) return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Loading/* default */.Z, {
        open: true
    }));
    if (!auth.isAuthenticated) router.push(routes/* ROUTES.AUTH_LOGIN */.Z.AUTH_LOGIN);
    if (auth.roles.every(function(role) {
        return role.role_id !== data_role/* ROLE_IDS.0 */.$[0] && role.role_id !== data_role/* ROLE_IDS.1 */.$[1] && role.role_id !== data_role/* ROLE_IDS.4 */.$[4];
    }) && !((ref1 = auth.subscription) === null || ref1 === void 0 ? void 0 : ref1.pay_on_account) && (!((ref2 = auth.subscription) === null || ref2 === void 0 ? void 0 : ref2.current_period_end) || auth.subscription.current_period_end * 1000 < Date.now())) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(components_RegisterSplashScreen, {
            logout: auth.logout
        }));
    }
    if (pendingPayment && !pendingPayment.pay_on_account) return(/*#__PURE__*/ (0,jsx_runtime.jsx)(components_ExtraPaymentSplashScreen, {
        logout: auth.logout
    }));
    return(// eslint-disable-next-line react/jsx-no-useless-fragment
    /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: children
    }));
};

;// CONCATENATED MODULE: ./src/components/dashboard/DashboardLayout.tsx













function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function DashboardLayout_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function DashboardLayout_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            DashboardLayout_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var DashboardLayoutRoot = (0,styled/* default */.ZP)("div")(function() {
    return {
        display: "flex",
        height: "100%",
        overflow: "hidden",
        width: "100%"
    };
});
var DashboardLayoutWrapper = (0,styled/* default */.ZP)("div")(function(param) {
    var theme = param.theme;
    return DashboardLayout_defineProperty({
        display: "flex",
        flex: "1 1 auto",
        overflow: "hidden",
        paddingTop: "64px"
    }, theme.breakpoints.up("lg"), {
        paddingLeft: "280px"
    });
});
var DashboardLayoutContainer = (0,styled/* default */.ZP)("div")({
    display: "flex",
    flex: "1 1 auto",
    overflow: "hidden"
});
var DashboardLayoutContent = (0,styled/* default */.ZP)("div")({
    width: "100%",
    height: "100%",
    overflow: "auto",
    position: "relative",
    WebkitOverflowScrolling: "touch"
});
var DashboardLayout = function(param) {
    var children = param.children, title = param.title, sx = param.sx, maxWidth = param.maxWidth;
    var replaceBetween = function replaceBetween(stringToModify, startIndex) {
        return stringToModify.substring(0, startIndex - 1) + stringToModify.substring(stringToModify.length);
    };
    var ref5 = _slicedToArray(react.useState(false), 2), isSidebarMobileOpen = ref5[0], setIsSidebarMobileOpen = ref5[1];
    var ref1 = _slicedToArray(react.useState(false), 2), isPermitted = ref1[0], setIsPermitted = ref1[1];
    var router = (0,next_router.useRouter)();
    var auth = (0,useAuth/* default */.Z)();
    var subscriptionPlans = (0,queries/* useSubscriptionPlans */.Xp)(auth.organizationId).subscriptionPlans;
    var isBasicPlan = react.useMemo(function() {
        var ref, ref2;
        if (!subscriptionPlans) return true;
        var ref3, ref4;
        var trainingSeats = ((ref3 = (ref = subscriptionPlans.items.find(function(plan) {
            return plan.product.name === "Training Seat";
        })) === null || ref === void 0 ? void 0 : ref.quantity) !== null && ref3 !== void 0 ? ref3 : 0) + ((ref4 = (ref2 = subscriptionPlans.items[0].db_product) === null || ref2 === void 0 ? void 0 : ref2.training_seats) !== null && ref4 !== void 0 ? ref4 : 0);
        if (trainingSeats === 0) return true;
        return false;
    }, [
        subscriptionPlans
    ]);
    var isIncidentManagementPlan = react.useMemo(function() {
        if (!subscriptionPlans) return false;
        var incidentManagementPlan = subscriptionPlans.items.find(function(plan) {
            return plan.product.name === api/* STRIPE_INCIDENT_MANAGEMENT_PLAN_NAME */.uQ;
        });
        return Boolean(incidentManagementPlan);
    }, [
        subscriptionPlans
    ]);
    var hasIncidentManagementAddon = react.useMemo(function() {
        if (!subscriptionPlans) return false;
        var imAddon = subscriptionPlans.items.find(function(plan) {
            return plan.product.name === "Incident Management Add-On" && plan.quantity > 0;
        });
        var imAddonIncludedPlan = subscriptionPlans.items.find(function(plan) {
            return plan.product.name === api/* STRIPE_INCIDENT_MANAGEMENT_PLAN_NAME */.uQ || plan.product.name === "VPO";
        });
        return Boolean(imAddon) || Boolean(imAddonIncludedPlan);
    }, [
        subscriptionPlans
    ]);
    react.useEffect(function() {
        if (router.pathname !== "/") {
            Object.entries(routes/* ROUTES */.Z).forEach(function(route) {
                // Base case
                if (auth.routes.includes(route[0]) && !router.pathname.includes("[")) {
                    if (route[1] === router.pathname) {
                        if (auth.routes.includes(route[0])) {
                            setIsPermitted(true);
                        }
                    }
                }
                // Case for where there is route parameters, such as a UUID that represents a record to fetch
                if (router.pathname.includes("[") && router.pathname.includes("[")) {
                    var sanitizedRoute = router.pathname;
                    var startStrip = sanitizedRoute.indexOf("[");
                    var strippedRoute = replaceBetween(sanitizedRoute, startStrip);
                    if (route[1] === strippedRoute) {
                        if (auth.routes.includes(route[0])) {
                            setIsPermitted(true);
                        }
                    }
                }
            });
        } else {
            setIsPermitted(true);
            return;
        }
        var ref;
        var basePath = (ref = router.pathname.split("/")[1]) !== null && ref !== void 0 ? ref : "";
        if (basePath === "training" || basePath === "policies") {
            if (isBasicPlan) setIsPermitted(false);
        }
        if ((hasIncidentManagementAddon || isIncidentManagementPlan) && (basePath === "incident-management" || basePath === "profile")) {
            if (basePath === "incident-management" && !auth.routes.includes("INCIDENT_MANAGEMENT")) {
                setIsPermitted(false);
            } else {
                setIsPermitted(true);
            }
        } else if (basePath === "incident-management") {
            setIsPermitted(false);
        }
        if (basePath === "incident-management" && "true" !== "true") {}
        // Auditor specific permissions
        if (auth.roles.some(function(r) {
            return r.role_id === data_role/* ROLE_IDS.5 */.$[5];
        })) {
            // Auditors can view the base clients path, but not the drilldown
            if (basePath === "clients" && router.pathname.includes("[")) setIsPermitted(false);
        }
    }, [
        router,
        auth,
        isBasicPlan,
        isIncidentManagementPlan
    ]);
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(AuthenticatedRoute, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("title", {
                children: [
                    title,
                    " | Privacy Horizon"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DashboardLayoutRoot, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dashboard_DashboardNavbar, {
                        onSidebarMobileOpen: function() {
                            setIsSidebarMobileOpen(true);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dashboard_DashboardSidebar, {
                        onMobileClose: function() {
                            setIsSidebarMobileOpen(false);
                        },
                        openMobile: isSidebarMobileOpen
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DashboardLayoutWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DashboardLayoutContainer, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DashboardLayoutContent, {
                                sx: DashboardLayout_objectSpread({
                                    p: 3,
                                    pb: 6
                                }, sx),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                                    disableGutters: !maxWidth,
                                    maxWidth: maxWidth !== null && maxWidth !== void 0 ? maxWidth : false,
                                    sx: {
                                        height: "100%"
                                    },
                                    children: isPermitted ? children : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                        container: true,
                                        spacing: 3,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                                alignItems: "center",
                                                container: true,
                                                item: true,
                                                justifyContent: "space-between",
                                                spacing: 3,
                                                xs: 12,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                                    item: true,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        color: "textSecondary",
                                                        variant: "overline",
                                                        children: "Unauthorized"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                style: {
                                                    position: "absolute",
                                                    height: 30,
                                                    width: 30,
                                                    backgroundColor: "red",
                                                    bottom: 0,
                                                    right: 0,
                                                    borderTopLeftRadius: 10
                                                }
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var dashboard_DashboardLayout = (DashboardLayout);


/***/ }),

/***/ 66349:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hk": function() { return /* binding */ ORGANIZATION_LIMIT; },
/* harmony export */   "ZR": function() { return /* binding */ USER_AVATAR_LIMIT; },
/* harmony export */   "Bm": function() { return /* binding */ INCIDENT_LIMIT; }
/* harmony export */ });
var ORGANIZATION_LIMIT = 50;
var USER_AVATAR_LIMIT = 5;
var INCIDENT_LIMIT = 5;


/***/ }),

/***/ 46648:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ROUTES; }
/* harmony export */ });
/**
 * Global routes table
 */ var ROUTES = {
    AUTH_LOGIN: "/auth/login",
    AUTH_FORGOT_PASSWORD: "/auth/forgot-password",
    AUTH_REGISTER: "/auth/register",
    AUTH_RESET_PASSWORD: "/auth/forgot-password-reset",
    AUTH_VERIFY_MFA: "/auth/verify-mfa",
    PLAN_SELECTION: "/plan-selection",
    PAYMENTS: "/payments",
    DASHBOARD: "/dashboard",
    RISK_REGISTRY: "/risk-registry",
    TRAINING: "/training",
    TRAINING_HUMAN_RISK: "/training/risk",
    TRAINING_TRAINING: "/training/training",
    DOCUMENTS: "/documents",
    COACH: "/coach",
    CHAT: "/chat",
    ORGANIZATIONS: "/organizations",
    CLIENTS: "/clients",
    CLIENTS_CREATE: "/clients/create",
    PHI_SETTINGS: "/phi-settings",
    ADMIN_DASHBOARD: "/admin-dashboard",
    COACH_DASHBOARD: "/coach-dashboard",
    RESOURCES: "/resources",
    RESOURCES_CREATE: "/resources/create",
    INCIDENT_MANAGEMENT: "/incident-management",
    INCIDENT_MANAGEMENT_SETTINGS: "/incident-management/settings",
    POLICY_TEMPLATES: "/policy-templates",
    ADMIN_POLICY_CREATE: "/policy-templates/create",
    ASSESSMENT_TEMPLATES: "/assessment-templates",
    CONTROL_TASK_TEMPLATES: "/controls",
    CONTROL_TASK_TEMPLATE_CREATE: "/controls/create",
    POLICIES: "/policies",
    POLICY_CREATE: "/policies/create",
    ASSESSMENTS: "/assessments",
    ASSESSMENT_CREATE: "/assessments/create",
    UNAUTHORIZED: "/unauthorized",
    PROFILE_USER: "/profile/user",
    PROFILE_ORGANIZATION: "/profile/organization",
    COMMUNITY: "/community",
    NOT_FOUND: "/404"
};


/***/ }),

/***/ 78470:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var contexts_AuthContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(71463);


var useAuth = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(contexts_AuthContext__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z);
};
/* harmony default export */ __webpack_exports__["Z"] = (useAuth);


/***/ }),

/***/ 92606:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ useSWRPaginate; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var swr_infinite__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44593);


function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var DEFAULT_FETCH_LIMIT = 1000;
var useSWRPaginate = function(_param) {
    var _limit = _param.limit, limit = _limit === void 0 ? DEFAULT_FETCH_LIMIT : _limit, url = _param.url, _requestParams = _param.requestParams, requestParams = _requestParams === void 0 ? "" : _requestParams, config = _objectWithoutProperties(_param, [
        "limit",
        "url",
        "requestParams"
    ]);
    var ref = _slicedToArray(react__WEBPACK_IMPORTED_MODULE_0__.useState(null), 2), data = ref[0], setData = ref[1];
    var extraParams = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(function() {
        return requestParams ? "&".concat(requestParams) : "";
    }, [
        requestParams
    ]);
    var queryStringExists = url ? url.includes("?") : false;
    var getKey = function(pageIndex) {
        return url ? "".concat(url).concat(queryStringExists ? "&" : "?", "page=").concat(pageIndex, "&limit=").concat(limit).concat(extraParams) : null;
    };
    var ref1 = (0,swr_infinite__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(getKey, _objectSpread({}, config, {
        revalidateFirstPage: false
    })), pages = ref1.data, error = ref1.error, size = ref1.size, setSize = ref1.setSize, isValidating = ref1.isValidating, mutate = ref1.mutate;
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function() {
        if (!pages || isValidating) {
            return;
        }
        if (pages[pages.length - 1].length === limit) {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            setSize(size + 1);
        } else {
            setData(pages.flatMap(function(d) {
                return d;
            }));
        }
    }, [
        pages,
        isValidating,
        setSize,
        size,
        limit
    ]);
    return {
        error: error,
        data: data,
        isValidating: isValidating,
        mutate: mutate
    };
};



/***/ }),

/***/ 43436:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82066);


var SpeakerPhone = (0,_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M18 2.99947C17.9999 2.82908 17.9563 2.66153 17.8733 2.51274C17.7902 2.36394 17.6706 2.23883 17.5256 2.14927C17.3806 2.05971 17.2152 2.00868 17.045 2.00101C16.8748 1.99335 16.7054 2.0293 16.553 2.10547L8.763 5.99947H5C4.20435 5.99947 3.44129 6.31554 2.87868 6.87815C2.31607 7.44076 2 8.20382 2 8.99947C2 9.79512 2.31607 10.5582 2.87868 11.1208C3.44129 11.6834 4.20435 11.9995 5 11.9995H5.28L7.051 17.3155C7.11735 17.5147 7.24472 17.6879 7.41505 17.8107C7.58538 17.9335 7.79004 17.9995 8 17.9995H9C9.26522 17.9995 9.51957 17.8941 9.70711 17.7066C9.89464 17.519 10 17.2647 10 16.9995V12.6175L16.553 15.8935C16.7054 15.9696 16.8748 16.0056 17.045 15.9979C17.2152 15.9903 17.3806 15.9392 17.5256 15.8497C17.6706 15.7601 17.7902 15.635 17.8733 15.4862C17.9563 15.3374 17.9999 15.1699 18 14.9995V2.99947Z",
        fillOpacity: "0.86"
    })
}), "SpeakerPhone");
/* harmony default export */ __webpack_exports__["Z"] = (SpeakerPhone);


/***/ }),

/***/ 21491:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "aG": function() { return /* reexport */ useActiveUsers; },
  "Rm": function() { return /* reexport */ useAdminUsers; },
  "YC": function() { return /* reexport */ useAssessment; },
  "w$": function() { return /* reexport */ useAssessmentControl; },
  "ii": function() { return /* reexport */ useAssessmentControlIds; },
  "wG": function() { return /* reexport */ useAssessmentControls; },
  "nd": function() { return /* reexport */ useAssessmentTemplates; },
  "_F": function() { return /* reexport */ useAssessments; },
  "FE": function() { return /* reexport */ useAssessmentsWithUserControls; },
  "pQ": function() { return /* reexport */ useBillingData; },
  "_X": function() { return /* reexport */ useChatParticipants; },
  "AR": function() { return /* reexport */ useCoachForUser/* useCoachForUser */.A; },
  "jW": function() { return /* reexport */ useCoaches; },
  "ky": function() { return /* reexport */ useDocument/* useDocument */.k; },
  "sg": function() { return /* reexport */ useDocuments; },
  "FX": function() { return /* reexport */ useEngagementsForOrganization; },
  "B1": function() { return /* reexport */ useEnterpriseAdminUsers; },
  "Rb": function() { return /* reexport */ useExternalIncidentSettings; },
  "oX": function() { return /* reexport */ useExternalOrganization; },
  "Yc": function() { return /* reexport */ useIncident; },
  "ru": function() { return /* reexport */ useIncidentSettings; },
  "OS": function() { return /* reexport */ useIncidentStakeholders; },
  "Yz": function() { return /* reexport */ useIncidents; },
  "o8": function() { return /* reexport */ useOrganization; },
  "Fk": function() { return /* reexport */ useOrganizationsWithCoachUsers; },
  "bM": function() { return /* reexport */ usePendingPaymentForOrg; },
  "g0": function() { return /* reexport */ usePlan; },
  "xn": function() { return /* reexport */ usePlans; },
  "De": function() { return /* reexport */ usePolicies; },
  "a7": function() { return /* reexport */ usePolicy; },
  "jR": function() { return /* reexport */ usePolicyTemplate; },
  "J$": function() { return /* reexport */ usePolicyTemplates; },
  "YS": function() { return /* reexport */ useResources; },
  "tj": function() { return /* reexport */ useResourcesWithAuthors; },
  "l5": function() { return /* reexport */ useRisks; },
  "VG": function() { return /* reexport */ useSessionsCreatedByUser; },
  "Jf": function() { return /* reexport */ useSessionsForOrganization; },
  "hC": function() { return /* reexport */ useSubscriptionCycles; },
  "Xp": function() { return /* reexport */ useSubscriptionPlans; },
  "ll": function() { return /* reexport */ useSubscriptionPlansIncludeScheduled; },
  "aF": function() { return /* reexport */ useUser; },
  "HO": function() { return /* reexport */ useUserAvatars; },
  "L6": function() { return /* reexport */ useUserPolicies; },
  "rW": function() { return /* reexport */ useWorks; }
});

// UNUSED EXPORTS: useIncidentStakeholder, useUsers

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./src/clients/axios.ts
var axios = __webpack_require__(21269);
// EXTERNAL MODULE: ./src/hooks/useAuth.ts
var hooks_useAuth = __webpack_require__(78470);
;// CONCATENATED MODULE: ./src/requests/queries/useUsers.ts




function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var useUsers = function() {
    var organizationId = useAuth().organizationId;
    var ref = useSWR(organizationId ? "organization/".concat(organizationId, "/user") : null), data = ref.data, error = ref.error, mutate = ref.mutate;
    return {
        users: data,
        usersError: error,
        isUsersLoading: !data && !error,
        mutateUsers: mutate
    };
};
var useActiveUsers = function() {
    var proxyOrganizationId = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
    var organizationId = (0,hooks_useAuth/* default */.Z)().organizationId;
    var targetOrganizationId = proxyOrganizationId ? proxyOrganizationId : organizationId;
    var ref = (0,dist/* default */.ZP)(targetOrganizationId ? "organization/".concat(targetOrganizationId, "/user/active") : null), data = ref.data, error = ref.error, mutate = ref.mutate;
    return {
        users: data,
        usersError: error,
        isUsersLoading: !data && !error,
        mutateUsers: mutate
    };
};
var useOrganizationsActiveUsers = function() {
    var _ref = _asyncToGenerator(runtime_default().mark(function _callee(unPaidOrganizaitionIds) {
        var response;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return axios/* axiosClient.get */.Ud.get("organization/organizations_ids/user/active", {
                        params: {
                            orgsIds: unPaidOrganizaitionIds
                        }
                    });
                case 2:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", {
                        users: response.data,
                        usersError: false,
                        isUsersLoading: false
                    });
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function useOrganizationsActiveUsers(unPaidOrganizaitionIds) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/requests/queries/useRisks.ts


var useRisks = function() {
    var organizationId = (0,hooks_useAuth/* default */.Z)().organizationId;
    var ref = (0,dist/* default */.ZP)(organizationId ? "organization/".concat(organizationId, "/risk-registry") : null), data = ref.data, error = ref.error, mutate = ref.mutate;
    return {
        risks: data,
        risksError: error,
        isRisksLoading: !data && !error,
        mutateRisks: mutate
    };
};

// EXTERNAL MODULE: ./src/hooks/useSWRPaginate.ts
var useSWRPaginate = __webpack_require__(92606);
;// CONCATENATED MODULE: ./src/requests/queries/useAssessments.ts


var useAssessments = function() {
    var organizationId = (0,hooks_useAuth/* default */.Z)().organizationId;
    var ref = (0,useSWRPaginate/* useSWRPaginate */.E)({
        url: organizationId ? "organization/".concat(organizationId, "/assessment") : undefined,
        limit: 200,
        revalidateIfStale: false,
        revalidateOnFocus: false,
        revalidateOnReconnect: false
    }), data = ref.data, error = ref.error, mutate = ref.mutate;
    return {
        assessments: data,
        assessmentsError: error,
        isAssessmentsLoading: !data && !error,
        mutateAssessments: mutate
    };
};

;// CONCATENATED MODULE: ./src/requests/queries/useAssessmentControls.ts


var useAssessmentControls = function(assessmentId) {
    var organizationId = (0,hooks_useAuth/* default */.Z)().organizationId;
    var ref = (0,dist/* default */.ZP)(assessmentId && organizationId ? "organization/".concat(organizationId, "/assessment/").concat(assessmentId, "/control") : null), data = ref.data, error = ref.error, mutate = ref.mutate;
    return {
        controls: data,
        controlsError: error,
        isControlsLoading: !data && !error,
        mutateControls: mutate
    };
};

;// CONCATENATED MODULE: ./src/requests/queries/useAssessment.ts


var useAssessment = function(assessmentId) {
    var organizationId = (0,hooks_useAuth/* default */.Z)().organizationId;
    var ref = (0,dist/* default */.ZP)(typeof assessmentId === "string" && organizationId ? "organization/".concat(organizationId, "/assessment/").concat(assessmentId) : null), data = ref.data, error = ref.error, mutate = ref.mutate;
    return {
        assessment: data,
        assessmentError: error,
        isAssessmentLoading: !data && !error,
        mutateAssessment: mutate
    };
};

;// CONCATENATED MODULE: ./src/requests/queries/usePolicyTemplates.ts

var usePolicyTemplates = function() {
    var ref = (0,dist/* default */.ZP)("policy"), data = ref.data, error = ref.error, mutate = ref.mutate;
    return {
        policyTemplates: data,
        policyTemplatesError: error,
        isPolicyTemplatesLoading: !data && !error,
        mutatePolicyTemplates: mutate
    };
};

;// CONCATENATED MODULE: ./src/requests/queries/usePolicyTemplate.ts

var usePolicyTemplate = function(policyTemplateId) {
    var ref = (0,dist/* default */.ZP)(policyTemplateId ? "policy/".concat(policyTemplateId) : null), data = ref.data, error = ref.error, mutate = ref.mutate;
    return {
        policyTemplate: data,
        policyTemplateError: error,
        isPolicyTemplateLoading: !data && !error,
        mutatePolicyTemplate: mutate
    };
};

;// CONCATENATED MODULE: ./src/requests/queries/usePolicy.ts


var usePolicy = function(policyId) {
    var organizationId = (0,hooks_useAuth/* default */.Z)().organizationId;
    var ref = (0,dist/* default */.ZP)(policyId && organizationId ? "organization/".concat(organizationId, "/policy/").concat(policyId) : null), data = ref.data, error = ref.error, mutate = ref.mutate;
    return {
        policy: data,
        policyError: error,
        isPolicyLoading: !data && !error,
        mutatePolicy: mutate
    };
};

;// CONCATENATED MODULE: ./src/requests/queries/usePolicies.ts


var usePolicies = function() {
    var organizationId = (0,hooks_useAuth/* default */.Z)().organizationId;
    var ref = (0,dist/* default */.ZP)(organizationId ? "organization/".concat(organizationId, "/policy") : null), data = ref.data, error = ref.error, mutate = ref.mutate;
    return {
        policies: data,
        policiesError: error,
        isPoliciesLoading: !data && !error,
        mutatePolicies: mutate
    };
};

;// CONCATENATED MODULE: ./src/requests/queries/useUserPolicies.tsx


var useUserPolicies = function() {
    var organizationId = (0,hooks_useAuth/* default */.Z)().organizationId;
    var user = (0,hooks_useAuth/* default */.Z)().user;
    var ref = (0,dist/* default */.ZP)(organizationId && user ? "organization/".concat(organizationId, "/user/policy") : null), data = ref.data, error = ref.error, mutate = ref.mutate;
    return {
        policies: data,
        policiesError: error,
        isPoliciesLoading: !data && !error,
        mutatePolicies: mutate
    };
};

;// CONCATENATED MODULE: ./src/requests/queries/useUser.ts


var useUser = function(userId) {
    var organizationId = (0,hooks_useAuth/* default */.Z)().organizationId;
    var ref = (0,dist/* default */.ZP)(userId && organizationId ? "organization/".concat(organizationId, "/user/").concat(userId) : null), data = ref.data, error = ref.error, mutate = ref.mutate;
    return {
        user: data,
        userError: error,
        isUserLoading: !data && !error,
        mutateUser: mutate
    };
};

;// CONCATENATED MODULE: ./src/requests/queries/useOrganization.ts

var useOrganization = function(organizationId) {
    var ref = (0,dist/* default */.ZP)(organizationId ? "organization/".concat(organizationId) : null), data = ref.data, error = ref.error, mutate = ref.mutate;
    return {
        organization: data,
        organizationError: error,
        isOrganizationLoading: !data && !error,
        mutateOrganization: mutate
    };
};

// EXTERNAL MODULE: ./src/requests/queries/useDocument.ts
var useDocument = __webpack_require__(24235);
;// CONCATENATED MODULE: ./src/requests/queries/useDocuments.ts


var useDocuments = function() {
    var organizationId = (0,hooks_useAuth/* default */.Z)().organizationId;
    var ref = (0,dist/* default */.ZP)(organizationId ? "organization/".concat(organizationId, "/document") : null), data = ref.data, error = ref.error, mutate = ref.mutate;
    return {
        documents: data,
        documentsError: error,
        isDocumentsLoading: !data && !error,
        mutateDocuments: mutate
    };
};

;// CONCATENATED MODULE: ./src/requests/queries/useAssessmentControlIds.ts


var useAssessmentControlIds = function(assessmentId) {
    var organizationId = (0,hooks_useAuth/* default */.Z)().organizationId;
    var ref = (0,dist/* default */.ZP)(typeof assessmentId === "string" && organizationId ? "organization/".concat(organizationId, "/assessment/").concat(assessmentId, "/control/ids") : null), data = ref.data, error = ref.error, mutate = ref.mutate;
    return {
        controlIds: data,
        controlIdsError: error,
        isControlIdsLoading: !data && !error,
        mutateControlIds: mutate
    };
};

;// CONCATENATED MODULE: ./src/requests/queries/useAssessmentControl.ts


var useAssessmentControl = function(assessmentId, controlId) {
    var organizationId = (0,hooks_useAuth/* default */.Z)().organizationId;
    var ref = (0,dist/* default */.ZP)(typeof assessmentId === "string" && typeof controlId === "string" && organizationId ? "organization/".concat(organizationId, "/assessment/").concat(assessmentId, "/control/").concat(controlId) : null), data = ref.data, error = ref.error, mutate = ref.mutate;
    return {
        control: data,
        controlError: error,
        isControlLoading: !data && !error,
        mutateControl: mutate
    };
};

;// CONCATENATED MODULE: ./src/requests/queries/useResources.ts

var useResources = function() {
    var ref = (0,dist/* default */.ZP)("resource"), data = ref.data, error = ref.error, mutate = ref.mutate;
    return {
        resources: data,
        resourcesError: error,
        isresourcesLoading: !data && !error,
        mutateResources: mutate
    };
};

;// CONCATENATED MODULE: ./src/requests/queries/usePlans.ts

var usePlans = function() {
    var ref = (0,dist/* default */.ZP)("payment/plan"), data = ref.data, error = ref.error, mutate = ref.mutate;
    return {
        plans: data,
        plansError: error,
        isPlansLoading: !data && !error,
        mutatePlans: mutate
    };
};

;// CONCATENATED MODULE: ./src/requests/queries/usePlan.ts

var usePlan = function(planId) {
    var ref = (0,dist/* default */.ZP)(typeof planId === "string" ? "payment/plan/".concat(planId) : null), data = ref.data, error = ref.error, mutate = ref.mutate;
    return {
        plan: data,
        planError: error,
        isPlanLoading: !data && !error,
        mutatePlan: mutate
    };
};

;// CONCATENATED MODULE: ./src/requests/queries/useSessions.ts

var useSessionsCreatedByUser = function(userId) {
    var ref = (0,dist/* default */.ZP)(typeof userId === "string" ? "coach/session/created-by/".concat(userId) : null), data = ref.data, error = ref.error, mutate = ref.mutate;
    return {
        sessions: data,
        sessionsError: error,
        isSessionsLoading: !data && !error,
        mutateSessions: mutate
    };
};
var useSessionsForOrganization = function(organizationId) {
    var ref = (0,dist/* default */.ZP)(typeof organizationId === "string" ? "coach/organization/".concat(organizationId, "/session") : null), data = ref.data, error = ref.error, mutate = ref.mutate;
    return {
        sessions: data,
        sessionsError: error,
        isSessionsLoading: !data && !error,
        mutateSessions: mutate
    };
};

;// CONCATENATED MODULE: ./src/requests/queries/useEngagements.ts

var useEngagementsForOrganization = function(organizationId) {
    var ref = (0,dist/* default */.ZP)(typeof organizationId === "string" ? "coach/organization/".concat(organizationId, "/engagement") : null), data = ref.data, error = ref.error, mutate = ref.mutate;
    return {
        engagements: data,
        engagementsError: error,
        isEngagementsLoading: !data && !error,
        mutateEngagements: mutate
    };
};

;// CONCATENATED MODULE: ./src/requests/queries/useAdminUsers.ts

var useAdminUsers = function() {
    var ref = (0,dist/* default */.ZP)("admin/user"), data = ref.data, error = ref.error, mutate = ref.mutate;
    return {
        adminUsers: data,
        adminUsersError: error,
        isAdminUsersLoading: !data && !error,
        mutateAdminUsers: mutate
    };
};

;// CONCATENATED MODULE: ./src/requests/queries/useCoaches.ts

var useCoaches = function() {
    var ref = (0,dist/* default */.ZP)("coach"), data = ref.data, error = ref.error, mutate = ref.mutate;
    return {
        coaches: data,
        coachesError: error,
        isCoachesLoading: !data && !error,
        mutateCoaches: mutate
    };
};

;// CONCATENATED MODULE: ./src/requests/queries/useAssessmentsWithUserControls.ts


var useAssessmentsWithUserControls = function() {
    var organizationId = (0,hooks_useAuth/* default */.Z)().organizationId;
    var ref = (0,dist/* default */.ZP)(organizationId ? "organization/".concat(organizationId, "/assessment/user/controls") : null), data = ref.data, error = ref.error, mutate = ref.mutate;
    return {
        assessmentsWithControls: data,
        assessmentsWithControlsError: error,
        isAssessmentsWithControlsLoading: !data && !error,
        mutateAssessmentsWithControls: mutate
    };
};

// EXTERNAL MODULE: ./src/constants/pagination-limits.ts
var pagination_limits = __webpack_require__(66349);
;// CONCATENATED MODULE: ./src/requests/queries/useOrganizationsWithCoachUsers.ts


var useOrganizationsWithCoachUsers = function(params) {
    var url = "organization/coach/";
    if (params.auditorId) {
        url += "auditor/".concat(params.auditorId);
    } else if (params.coachId) {
        url += params.coachId;
    }
    var ref = (0,useSWRPaginate/* useSWRPaginate */.E)({
        url: url,
        limit: pagination_limits/* ORGANIZATION_LIMIT */.Hk,
        revalidateIfStale: false,
        revalidateOnFocus: false,
        revalidateOnReconnect: false
    }), data = ref.data, error = ref.error, mutate = ref.mutate;
    return {
        organizations: data,
        organizationsError: error,
        isOrganizationsLoading: !data && !error,
        mutateOrganizations: mutate
    };
};

;// CONCATENATED MODULE: ./src/requests/queries/useSubscriptionPlans.ts

var useSubscriptionPlans = function(organizationId) {
    var ref = (0,dist/* default */.ZP)(typeof organizationId === "string" ? "organization/".concat(organizationId, "/subscription-plan") : null), data = ref.data, error = ref.error;
    return {
        subscriptionPlans: data,
        subscriptionPlansError: error,
        isSubscriptionPlansLoading: !data && !error
    };
};
var useSubscriptionPlansIncludeScheduled = function(organizationId) {
    var ref = (0,dist/* default */.ZP)(typeof organizationId === "string" ? "organization/".concat(organizationId, "/subscription-plan/scheduled") : null), data = ref.data, error = ref.error;
    return {
        subscriptionPlans: data,
        subscriptionPlansError: error,
        isSubscriptionPlansLoading: !data && !error
    };
};

;// CONCATENATED MODULE: ./src/requests/queries/useSubscriptionCycles.ts

var useSubscriptionCycles = function(organizationId) {
    var ref = (0,dist/* default */.ZP)(typeof organizationId === "string" ? "organization/".concat(organizationId, "/subscription-cycles") : null), data = ref.data, error = ref.error;
    return {
        subscriptionCycles: data,
        subscriptionCyclesError: error,
        isSubscriptionCyclesLoading: !data && !error
    };
};

;// CONCATENATED MODULE: ./src/requests/queries/useWorks.ts

var useWorks = function(title) {
    var data = (0,dist/* default */.ZP)(title ? "works/".concat(title) : null).data;
    return {
        data: data
    };
};

;// CONCATENATED MODULE: ./src/requests/queries/useResourcesWithAuthors.ts

var useResourcesWithAuthors = function() {
    var ref = (0,dist/* default */.ZP)("resource/with-author"), data = ref.data, error = ref.error, mutate = ref.mutate;
    return {
        resources: data,
        resourcesError: error,
        isresourcesLoading: !data && !error,
        mutateResources: mutate
    };
};

// EXTERNAL MODULE: ./src/requests/queries/useCoachForUser.ts
var useCoachForUser = __webpack_require__(78240);
;// CONCATENATED MODULE: ./src/requests/queries/usePendingPaymentForOrg.ts

var usePendingPaymentForOrg = function(organizationId) {
    var ref = (0,dist/* default */.ZP)(organizationId ? "payment/pending/".concat(organizationId) : null), data = ref.data, error = ref.error, mutate = ref.mutate;
    return {
        pendingPayment: data,
        pendingPaymentError: error,
        isPendingPaymentLoading: data === undefined && !error,
        mutatePendingPayment: mutate
    };
};

;// CONCATENATED MODULE: ./src/requests/queries/useAssessmentTemplates.ts

var useAssessmentTemplates = function(assessmentTemplateId) {
    var ref = (0,dist/* default */.ZP)(typeof assessmentTemplateId === "string" ? "assessment-template/".concat(assessmentTemplateId) : "assessment-template"), data = ref.data, error = ref.error, mutate = ref.mutate;
    return {
        assessmentTemplates: data,
        assessmentError: error,
        isAssessmentTemplateLoading: !data && !error,
        mutateAssessmentTemplate: mutate
    };
};

;// CONCATENATED MODULE: ./src/requests/queries/useEnterpriseAdminUsers.ts

var useEnterpriseAdminUsers = function() {
    var ref = (0,dist/* default */.ZP)("admin/user/enterprise"), data = ref.data, error = ref.error, mutate = ref.mutate;
    return {
        enterpriseUsers: data,
        enterpriseUsersError: error,
        isEnterpriseUsersLoading: !data && !error,
        mutateEnterpriseUsers: mutate
    };
};

;// CONCATENATED MODULE: ./src/requests/queries/useChatParticipants.ts

var useChatParticipants = function(conversationSid) {
    var ref = (0,dist/* default */.ZP)(conversationSid ? "chat/conversation/".concat(conversationSid, "/participants") : null), data = ref.data, error = ref.error, mutate = ref.mutate;
    return {
        participants: data,
        participantsError: error,
        isParticipantsLoading: !data && !error,
        mutateParticipants: mutate
    };
};

;// CONCATENATED MODULE: ./src/requests/queries/useBillingData.ts

var useBillingData = function(organizationId) {
    var ref = (0,dist/* default */.ZP)(typeof organizationId === "string" ? "organization/".concat(organizationId, "/billing") : null), data = ref.data, error = ref.error, mutate = ref.mutate;
    return {
        billingData: data,
        billingDataError: error,
        isBillingDataLoading: !data && !error,
        mutatePlan: mutate
    };
};

;// CONCATENATED MODULE: ./src/requests/queries/useIncidentStakeholder.ts


var useIncidentStakeholder = function(stakeholderId) {
    var organizationId = useAuth().organizationId;
    var ref = useSWR(typeof stakeholderId === "string" && organizationId ? "incident-management/".concat(organizationId, "/stakeholder/").concat(stakeholderId) : null), data = ref.data, error = ref.error, mutate = ref.mutate;
    return {
        incidentStakeholder: data,
        incidentStakeholderError: error,
        isincidentStakeholderLoading: !data && !error,
        mutateincidentStakeholder: mutate
    };
};

;// CONCATENATED MODULE: ./src/requests/queries/useIncidentStakeholders.ts


var useIncidentStakeholders = function() {
    var organizationId = (0,hooks_useAuth/* default */.Z)().organizationId;
    var ref = (0,dist/* default */.ZP)(organizationId ? "incident-management/".concat(organizationId, "/stakeholder") : null), data = ref.data, error = ref.error, mutate = ref.mutate;
    return {
        incidentStakeholders: data,
        incidentStakeholdersError: error,
        isIncidentStakeholdersLoading: !data && !error,
        mutateincidentStakeholders: mutate
    };
};

;// CONCATENATED MODULE: ./src/requests/queries/useIncidentSettings.ts


var useIncidentSettings = function() {
    var organizationId = (0,hooks_useAuth/* default */.Z)().organizationId;
    var ref = (0,dist/* default */.ZP)(organizationId ? "incident-management/".concat(organizationId, "/settings") : null), data = ref.data, error = ref.error, mutate = ref.mutate;
    return {
        incidentSettings: data,
        incidentSettingsError: error,
        isIncidentSettingsLoading: data === undefined && !error,
        mutateincidentSettings: mutate
    };
};

;// CONCATENATED MODULE: ./src/requests/queries/useIncidents.ts



var useIncidents = function(isEnterpriseView) {
    var organizationId = (0,hooks_useAuth/* default */.Z)().organizationId;
    var url = organizationId ? "incident-management/".concat(organizationId, "/incident").concat(isEnterpriseView ? "/enterprise" : "") : undefined;
    var ref = (0,useSWRPaginate/* useSWRPaginate */.E)({
        url: url,
        limit: pagination_limits/* INCIDENT_LIMIT */.Bm,
        revalidateIfStale: false,
        revalidateOnFocus: false,
        revalidateOnReconnect: false
    }), data = ref.data, error = ref.error, mutate = ref.mutate;
    return {
        incidents: data !== null && data !== void 0 ? data : undefined,
        incidentsError: error,
        isIncidentsLoading: !data && !error,
        mutateIncidents: mutate
    };
};

;// CONCATENATED MODULE: ./src/requests/queries/useIncident.ts


var useIncident = function(incidentVersionId) {
    var organizationId = (0,hooks_useAuth/* default */.Z)().organizationId;
    var ref = (0,dist/* default */.ZP)(organizationId && incidentVersionId ? "incident-management/".concat(organizationId, "/incident/").concat(incidentVersionId) : null), data = ref.data, error = ref.error, mutate = ref.mutate;
    return {
        incident: data,
        incidentError: error,
        isIncidentLoading: !data && !error,
        mutateIncident: mutate
    };
};

;// CONCATENATED MODULE: ./src/requests/queries/useUserAvatars.ts


var useUserAvatars = function(organizationId, userIds) {
    var encodedUserIds = encodeURIComponent(JSON.stringify(userIds));
    var url = "organization/".concat(organizationId, "/user/avatar?users=").concat(encodedUserIds);
    var ref = (0,useSWRPaginate/* useSWRPaginate */.E)({
        url: url,
        limit: pagination_limits/* USER_AVATAR_LIMIT */.ZR,
        revalidateIfStale: false,
        revalidateOnFocus: false,
        revalidateOnReconnect: false
    }), data = ref.data, error = ref.error, mutate = ref.mutate;
    return {
        userAvatars: data,
        userAvatarsError: error,
        isUserAvatarsLoading: !data && !error,
        mutateUserAvatars: mutate
    };
};

;// CONCATENATED MODULE: ./src/requests/queries/useExternalIncidentSettings.ts

var useExternalIncidentSettings = function(orgId) {
    var ref = (0,dist/* default */.ZP)(orgId ? "incident-management/external-submission/settings?organization_id=".concat(orgId) : null), data = ref.data, error = ref.error, mutate = ref.mutate;
    return {
        incidentSettings: data,
        incidentSettingsError: error,
        isIncidentSettingsLoading: data === undefined && !error,
        mutateincidentSettings: mutate
    };
};

;// CONCATENATED MODULE: ./src/requests/queries/useExternalOrganization.ts

var useExternalOrganization = function(organizationId) {
    var ref = (0,dist/* default */.ZP)(organizationId ? "incident-management/external-submission/organization?organization_id=".concat(organizationId) : null), data = ref.data, error = ref.error, mutate = ref.mutate;
    return {
        organization: data,
        organizationError: error,
        isOrganizationLoading: !data && !error,
        mutateOrganization: mutate
    };
};

;// CONCATENATED MODULE: ./src/requests/queries/index.ts













































/***/ }),

/***/ 9904:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ useAddons; }
/* harmony export */ });
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8100);

var useAddons = function() {
    var currency = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "CAD";
    var ref = (0,swr__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)("payment/price/addons?currency=".concat(currency)), data = ref.data, error = ref.error, mutate = ref.mutate;
    return {
        prices: data === null || data === void 0 ? void 0 : data.prices,
        addons: data === null || data === void 0 ? void 0 : data.addOns,
        addonsError: error,
        isAddonsLoading: !data && !error,
        mutateAddons: mutate
    };
};


/***/ }),

/***/ 78240:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ useCoachForUser; }
/* harmony export */ });
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8100);

var useCoachForUser = function(userId) {
    var ref = (0,swr__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(userId ? "coach/user/".concat(userId) : null), data = ref.data, error = ref.error, mutate = ref.mutate;
    return {
        coach: data,
        coachError: error,
        isCoachLoading: !data && !error,
        mutateCoach: mutate
    };
};


/***/ }),

/***/ 56694:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ useCoupons; }
/* harmony export */ });
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8100);

var useCoupons = function() {
    var ref = (0,swr__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)("payment/coupon"), data = ref.data, error = ref.error;
    return {
        coupons: data,
        couponsError: error,
        isCouponsLoading: !data && !error
    };
};


/***/ }),

/***/ 24235:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ useDocument; }
/* harmony export */ });
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8100);
/* harmony import */ var hooks_useAuth__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78470);


var useDocument = function(documentId) {
    var organizationId = (0,hooks_useAuth__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().organizationId;
    var ref = (0,swr__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(organizationId && typeof documentId === "string" ? "organization/".concat(organizationId, "/document/").concat(documentId) : null), data = ref.data, error = ref.error, mutate = ref.mutate;
    return {
        document: data,
        documentError: error,
        isDocumentLoading: !data && !error,
        mutateDocument: mutate
    };
};


/***/ }),

/***/ 20411:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "zE": function() { return /* reexport */ ActivityLogType; },
  "ZA": function() { return /* reexport */ BreachIncidentType; },
  "M_": function() { return /* reexport */ index_browser.ControlTaskPriority; },
  "oY": function() { return /* reexport */ index_browser.ControlTaskRiskTreatmentStrategy; },
  "u8": function() { return /* reexport */ index_browser.ControlTaskStatus; },
  "uQ": function() { return /* reexport */ STRIPE_INCIDENT_MANAGEMENT_PLAN_NAME; }
});

// UNUSED EXPORTS: ACTION_IDS, MENU_IDS

// EXTERNAL MODULE: ./node_modules/@prisma/client/index-browser.js
var index_browser = __webpack_require__(70385);
;// CONCATENATED MODULE: ./src/types/api/permissions.ts

var ACTION_IDS = Object.keys(index_browser.ActionId);
var MENU_IDS = Object.keys(index_browser.MenuId);

;// CONCATENATED MODULE: ./src/types/api/control-task.ts



;// CONCATENATED MODULE: ./src/types/api/payment.ts
var STRIPE_INCIDENT_MANAGEMENT_PLAN_NAME = "Incident Management Plan";

;// CONCATENATED MODULE: ./src/types/api/incident.ts
var ActivityLogType;
(function(ActivityLogType) {
    ActivityLogType["Intake"] = "Intake";
    ActivityLogType["Triage"] = "Triage";
    ActivityLogType["ActionItem"] = "ActionItem";
    ActivityLogType["AdditionalActionItem"] = "AdditionalActionItem";
})(ActivityLogType || (ActivityLogType = {}));

;// CONCATENATED MODULE: ./src/types/api/breach-incident-category.ts
var BreachIncidentType;
(function(BreachIncidentType) {
    BreachIncidentType["Incident"] = "Incident";
    BreachIncidentType["Breach"] = "Breach";
})(BreachIncidentType || (BreachIncidentType = {}));

;// CONCATENATED MODULE: ./src/types/api/index.ts



























/***/ })

}]);